// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../Img/shutterstock_2416028885 (1).png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ============================
   BREAKPOINTS
============================ */
/* ============================
   HELPERS
============================ */
.btn {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  padding: 0.5rem 2rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  border: 2px solid transparent;
  background: transparent;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease, transform 0.2s ease;
  /* ============================
     VARIANTS
  ============================ */
}
.btn--primary {
  color: #1e2150;
  border-radius: 15px;
  border: 2px solid #1e2150;
}
.btn--primary:hover {
  background-color: rgb(18.8727272727, 20.76, 50.3272727273);
}
.btn--secondary {
  background-color: #9eba44;
  color: #ffffff;
}
.btn--secondary:hover {
  background-color: rgb(132.6204724409, 156.1228346457, 57.0771653543);
}
.btn--accent {
  background-color: #facc15;
  color: #111827;
}
.btn--accent:hover {
  background-color: rgb(225.3841004184, 181.0778242678, 4.8158995816);
}
.btn--outline {
  border-color: #1e2150;
  color: #1e2150;
}
.btn--outline:hover {
  background-color: #1e2150;
  color: #ffffff;
}
.btn {
  /* ============================
     ICON SUPPORT
  ============================ */
}
.btn--with-icon .btn__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s ease;
}
.btn--with-icon:hover .btn__icon {
  transform: translateX(4px);
}
.btn {
  /* ============================
     READ MORE CTA
  ============================ */
}
.btn--read-more {
  margin-top: 2rem;
  border-color: #1e2150;
  color: #1e2150;
  padding: 0.5rem 2rem;
  border-radius: 999px;
  font-size: 1rem;
  min-width: 220px;
}
.btn--read-more .btn__icon {
  background: #1e2150;
  color: #ffffff;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  font-size: 1rem;
  font-weight: 700;
}
.btn--read-more:hover {
  background-color: #1e2150;
  color: #ffffff;
}
.btn--read-more:hover .btn__icon {
  transform: translateX(8px);
}

.layout-container {
  max-width: 1400px;
  margin: 0 auto;
  padding-left: 70px;
  padding-right: 70px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
}
.layout-container main {
  flex: 1 1;
  padding: 2rem 0;
}
@media (max-width: 1200px) {
  .layout-container {
    padding-left: 50px;
    padding-right: 50px;
  }
}
@media (max-width: 768px) {
  .layout-container {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (max-width: 576px) {
  .layout-container {
    padding-left: 15px;
    padding-right: 15px;
  }
}

.footer {
  width: 100%;
  padding: 2rem 0 1.5rem 0;
  text-align: center;
}
.footer__divider {
  width: 85%;
  margin: 0 auto 2rem;
  border: none;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
}
.footer__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.footer__logo {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}
.footer__logo img {
  width: 200px;
  height: 50px;
  object-fit: contain;
}
.footer__logo .footer__brand {
  font-weight: 800;
  color: #1e2150;
  font-size: 1.1rem;
}
.footer__text {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #111827;
  font-size: 0.95rem;
  flex-wrap: wrap;
  justify-content: center;
}
.footer__text a {
  color: #111827;
  text-decoration: none;
  transition: color 0.2s ease;
}
.footer__text a:hover {
  color: #1e2150;
}
.footer__text span {
  opacity: 0.8;
}

/* 🔹 Responsive */
@media (max-width: 768px) {
  .footer__text {
    flex-direction: column;
    gap: 0.3rem;
  }
}
.navbar {
  position: relative;
  width: 100%;
  z-index: 3000;
  background: transparent;
  border-radius: 0 0 20px 20px;
  overflow: visible;
}
.navbar.scrolled {
  background: rgba(200, 200, 200, 0.93);
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
}
.navbar {
  /* ---------- TOP BAR ---------- */
}
.navbar__top {
  max-width: 1400px;
  margin: 0 auto;
  padding: clamp(4px, 1vw, 6px) clamp(15px, 3vw, 20px);
  display: flex;
  justify-content: flex-end;
  font-size: clamp(12px, 2.5vw, 14px);
  font-weight: 600;
}
@media (max-width: 576px) {
  .navbar__top {
    justify-content: center;
  }
}
.navbar .navbar__lang button {
  border: none;
  background: none;
  cursor: pointer;
  padding: clamp(4px, 1vw, 8px);
  font-size: clamp(12px, 2.5vw, 14px);
}
.navbar {
  /* ---------- PHONE BUTTON LOGIC ---------- */
}
.navbar .navbar__phone--desktop {
  display: flex;
  align-items: center;
  font-weight: 600;
  gap: clamp(6px, 1.5vw, 8px);
  font-size: clamp(14px, 2.5vw, 16px);
  color: #111827;
  text-decoration: none;
}
.navbar .navbar__phone--mobile {
  display: none;
}
@media (max-width: 768px) {
  .navbar .navbar__phone--desktop {
    display: none;
  }
  .navbar .navbar__phone--mobile {
    display: flex;
    margin-top: clamp(15px, 3vw, 20px);
    font-size: clamp(18px, 4vw, 20px);
    font-weight: 700;
    align-items: center;
    gap: clamp(8px, 2vw, 10px);
    color: #1e2150;
    text-decoration: none;
  }
}
.navbar {
  /* ---------- MAIN NAVBAR ---------- */
}
.navbar__bottom {
  padding: clamp(8px, 2vw, 10px) 0;
}
.navbar__container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 clamp(15px, 3vw, 20px);
}
.navbar {
  /* ---------- LOGO ---------- */
}
.navbar__logo img {
  width: clamp(150px, 20vw, 200px);
  height: clamp(45px, 8vw, 60px);
  object-fit: contain;
  cursor: pointer;
}
@media (max-width: 768px) {
  .navbar__logo img {
    width: clamp(120px, 25vw, 160px);
    height: clamp(36px, 10vw, 48px);
  }
}
@media (max-width: 480px) {
  .navbar__logo img {
    width: clamp(100px, 30vw, 140px);
    height: clamp(30px, 12vw, 42px);
  }
}
.navbar {
  /* ---------- MENU ---------- */
}
.navbar__menu {
  display: flex;
  gap: clamp(20px, 4vw, 30px);
}
.navbar__menu a {
  position: relative;
  font-size: clamp(14px, 2.5vw, 16px);
  color: #111827;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
  /* underline */
}
.navbar__menu a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -8px;
  width: 0%;
  height: 2px;
  background: #111827;
  border-radius: 2px;
  transition: 0.25s ease;
}
.navbar__menu a:hover {
  color: #111827;
}
.navbar__menu a:hover::after {
  width: 100%;
}
.navbar__menu a {
  /* ✅ ACTIVE LINK */
}
.navbar__menu a.active {
  color: #111827;
}
.navbar__menu a.active::after {
  width: 100%;
}
.navbar__menu {
  /* MOBILE MENU */
}
@media (max-width: 992px) {
  .navbar__menu {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: clamp(100px, 15vw, 120px);
    gap: clamp(20px, 4vw, 25px);
    opacity: 0;
    pointer-events: none;
    transform: translateY(-15px);
    z-index: 99999 !important;
    transition: all 0.35s ease;
  }
  .navbar__menu.open {
    opacity: 1;
    pointer-events: auto;
    transform: translateY(0);
  }
  .navbar__menu a {
    font-size: clamp(18px, 5vw, 22px);
    padding: clamp(8px, 2vw, 12px);
    /* mobile underline fix */
  }
  .navbar__menu a::after {
    bottom: -4px;
  }
}
@media (max-width: 576px) {
  .navbar__menu {
    padding-top: clamp(80px, 12vw, 100px);
    gap: clamp(15px, 3vw, 20px);
  }
  .navbar__menu a {
    font-size: clamp(16px, 6vw, 20px);
  }
}
.navbar {
  /* ---------- HAMBURGER ---------- */
}
.navbar .hamburger {
  display: none;
  flex-direction: column;
  gap: clamp(3px, 1vw, 5px);
  border: none;
  background: transparent;
  cursor: pointer;
  z-index: 100000 !important;
  padding: clamp(8px, 2vw, 12px);
}
.navbar .hamburger span {
  width: clamp(24px, 4vw, 28px);
  height: clamp(2px, 0.5vw, 3px);
  background: #1e2150;
  border-radius: 2px;
  transition: all 0.3s ease;
}
.navbar .hamburger.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
.navbar .hamburger.active span:nth-child(2) {
  opacity: 0;
}
.navbar .hamburger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(7px, -6px);
}
@media (max-width: 992px) {
  .navbar .hamburger {
    display: flex;
  }
}
@media (max-width: 576px) {
  .navbar .hamburger {
    gap: clamp(2px, 0.8vw, 4px);
  }
}
.navbar {
  /* ---------- RESPONSIVE ADJUSTMENTS ---------- */
}
@media (max-width: 1024px) {
  .navbar__container {
    padding: 0 clamp(10px, 2vw, 15px);
  }
}
@media (max-width: 768px) {
  .navbar {
    border-radius: 0 0 clamp(12px, 2vw, 16px) clamp(12px, 2vw, 16px);
  }
  .navbar.scrolled {
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
  }
}
@media (max-width: 576px) {
  .navbar {
    border-radius: 0 0 10px 10px;
  }
  .navbar__top {
    padding: 3px 10px;
  }
  .navbar__bottom {
    padding: 6px 0;
  }
  .navbar__container {
    padding: 0 10px;
  }
}
@media (max-width: 480px) {
  .navbar {
    border-radius: 0;
  }
  .navbar__container {
    padding: 0 8px;
  }
}

/* =========================
   WRAPPER
========================= */
.hero__wrapper {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}

/* =========================
   SLIDER CARD
========================= */
.hero__sliderCard {
  position: relative;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  min-height: 360px;
  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.08);
}

/* =========================
   SLIDE ROW
========================= */
.hero__row {
  display: flex;
  align-items: center;
  gap: 3rem;
  padding: 44px;
  min-height: inherit;
  opacity: 0;
  transform: translateX(60px) scale(0.96);
}
@media (max-width: 768px) {
  .hero__row {
    flex-direction: column;
    text-align: center;
    padding: 34px 24px;
  }
}

.hero__row--next {
  animation: slideNext 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.hero__row--prev {
  animation: slidePrev 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

/* =========================
   CONTENT
========================= */
.hero__content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  opacity: 0;
  animation: fadeUp 0.65s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: 0.25s;
}
.hero__content h1 {
  font-weight: 700;
  margin-bottom: 1rem;
}
.hero__content p {
  max-width: 520px;
  margin-bottom: 2rem;
  line-height: 1.6;
}

/* =========================
   IMAGE
========================= */
.btn1 {
  width: 300px;
}

.hero__image {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  opacity: 0;
  animation: imageFloat 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;
  animation-delay: 0.35s;
}
.hero__image img {
  max-width: 100%;
  height: auto;
  border-radius: 20px;
}
@media (max-width: 768px) {
  .hero__image {
    display: none;
  }
}

/* =========================
   ARROWS
========================= */
.hero__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 60px;
  background: none;
  border: none;
  cursor: pointer;
  color: #1e2150;
  opacity: 0.5;
  transition: 0.25s;
  z-index: 10;
}
.hero__arrow:hover {
  opacity: 1;
  transform: translateY(-50%) scale(1.1);
}

.hero__arrow--left {
  left: 14px;
}

.hero__arrow--right {
  right: 14px;
}

/* =========================
   DOTS
========================= */
.hero__dots {
  display: flex;
  justify-content: center;
  gap: 10px;
  padding: 18px 0;
}

.hero__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: #ccc;
  cursor: pointer;
}
.hero__dot.active {
  background: #1e2150;
}

/* =========================
   ANIMATIONS
========================= */
@keyframes slideNext {
  from {
    opacity: 0;
    transform: translateX(60px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
@keyframes slidePrev {
  from {
    opacity: 0;
    transform: translateX(-60px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(18px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes imageFloat {
  from {
    opacity: 0;
    transform: translateX(40px) scale(0.94);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
/* =========================
   MOBILE HERO FIX
========================= */
@media (max-width: 768px) {
  .hero__sliderCard {
    min-height: auto;
    border-radius: 14px;
  }
  .hero__row {
    flex-direction: column-reverse; /* ⬅️ image վերև */
    gap: 18px;
    padding: 22px 18px;
    text-align: center;
    transform: none;
  }
  .hero__content {
    animation: none;
    opacity: 1;
  }
  .hero__content h1 {
    font-size: 1.45rem;
    line-height: 1.25;
  }
  .hero__content p {
    max-width: 100%;
    margin-bottom: 18px;
    font-size: 0.95rem;
    line-height: 1.6;
  }
  /* 👇 ամենակարևորը — նկարը այլևս չի անհետանում */
  .hero__image {
    display: flex !important;
    justify-content: center;
    animation: none;
    opacity: 1;
  }
  .hero__image img {
    width: 100%;
    max-width: 320px;
    border-radius: 16px;
  }
  /* arrows mobile-ում պետք չեն */
  .hero__arrow {
    display: none;
  }
}
.services {
  background: #f9fafb;
  padding: clamp(3rem, 8vw, 5rem) 0;
  text-align: center;
  /* =========================
     HEADER
  ========================= */
}
.services__header {
  max-width: 1260px;
  margin: 0 auto clamp(2rem, 6vw, 3rem);
}
.services__title {
  font-size: clamp(1.8rem, 6vw, 3rem);
  font-weight: 800;
  color: #1e2150;
}
.services {
  /* =========================
     FRAME (ARROWS LIVE HERE)
  ========================= */
}
.services__frame {
  position: relative;
  max-width: 1260px;
  margin: 0 auto;
}
.services {
  /* =========================
     ARROWS
  ========================= */
}
.services__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 44px;
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 60px;
  line-height: 1;
  color: #1e2150;
  z-index: 10;
  transition: opacity 0.2s ease;
}
.services__arrow--left {
  left: -22px;
}
.services__arrow--right {
  right: -22px;
}
.services {
  /* TRACK */
}
.services .services__track--simple {
  display: flex;
  gap: clamp(1rem, 3vw, 2rem);
  will-change: opacity, transform, filter;
  transition: opacity 0.45s cubic-bezier(0.4, 0, 0.2, 1), transform 0.45s cubic-bezier(0.4, 0, 0.2, 1), filter 0.45s cubic-bezier(0.4, 0, 0.2, 1);
}
.services {
  /* NEXT (աջից ձախ) */
}
.services .services__track--simple.is-animating.next {
  opacity: 0;
  transform: translateX(-34px) scale(0.96);
  filter: blur(2px);
}
.services {
  /* PREV (ձախից աջ) */
}
.services .services__track--simple.is-animating.prev {
  opacity: 0;
  transform: translateX(34px) scale(0.96);
  filter: blur(2px);
}
.services {
  /* CARDS — soft breathing */
}
.services .services__track--simple .card {
  transition: transform 0.45s ease, box-shadow 0.45s ease;
}
.services .services__track--simple.is-animating .card {
  transform: scale(0.97);
}
.services .services__track {
  display: flex;
  transition: transform 0.6s ease;
  will-change: transform;
}
.services {
  /* =========================
     SLIDER CONTAINER
  ========================= */
}
.services__track {
  display: flex;
  gap: clamp(1rem, 3vw, 2rem);
}
.services {
  /* =========================
     CARD
  ========================= */
}
.services .card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 1.333rem);
  background: #fff;
  border-radius: 16px;
  padding: 2.2rem 1.6rem 2.4rem;
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  will-change: transform;
  /* badge */
}
.services .card__badge {
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.2rem;
  transition: transform 0.35s ease;
}
.services .card__badge img {
  width: 82px;
  height: 82px;
  object-fit: contain;
}
.services .card h3 {
  color: #1e2150;
  font-weight: 700;
  margin-bottom: 1rem;
  position: relative;
}
.services .card h3::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -10px;
  transform: translateX(-50%);
  width: 0%;
  height: 2px;
  border-radius: 2px;
  background: #1e2150;
  transition: width 0.35s ease;
}
.services .card p {
  color: #555;
  line-height: 1.6;
  flex-grow: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.services .card .btn {
  margin-top: 1.4rem;
}
.services {
  /* =========================
     HOVER (DESKTOP ONLY)
  ========================= */
}
@media (hover: hover) {
  .services .card:hover {
    transform: translateY(-10px);
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.14), 0 0 0 2px rgba(44, 65, 144, 0.12), 0 0 24px rgba(158, 186, 68, 0.18);
  }
  .services .card:hover .card__badge {
    transform: rotate(-4deg) scale(1.05);
  }
  .services .card:hover h3::after {
    width: 55%;
  }
}
.services {
  /* =========================
     RESPONSIVE
  ========================= */
}
@media (max-width: 992px) {
  .services .card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 1rem);
  }
}
@media (max-width: 768px) {
  .services__arrow {
    display: none;
  }
  .services .services__track--simple {
    display: flex;
    gap: 1.2rem;
  }
}
@media (max-width: 768px) {
  .services .card {
    flex: 0 0 100%;
    min-height: auto;
  }
  .services .services__container {
    overflow: hidden;
    touch-action: pan-y;
  }
  .services__arrow {
    width: 38px;
    height: 38px;
    font-size: 26px;
  }
  .services__arrow--left {
    left: 6px;
  }
  .services__arrow--right {
    right: 6px;
  }
}

.results {
  background: #f9fafb;
  text-align: center;
  padding: clamp(3rem, 8vw, 5rem) 0;
  /* =========================
     TITLES
  ========================= */
}
.results__title {
  font-size: clamp(1.4rem, 4vw, 2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: 3rem;
}
.results__subtitle {
  font-size: 1.2rem;
  font-weight: 600;
  color: #1e2150;
  margin-bottom: 2.5rem;
}
.results .results__subtitle {
  font-size: clamp(1.4rem, 4vw, 2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: 3rem;
}
.results {
  /* =========================
     STATS
  ========================= */
}
.results__stats {
  display: flex;
  justify-content: center;
  gap: clamp(3rem, 10vw, 8rem);
  flex-wrap: wrap;
  margin-bottom: 3rem;
}
.results__stats p {
  font-size: 0.9rem;
  color: #555;
}
.results__stats h3 {
  font-size: 1.6rem;
  color: #1e2150;
  margin-top: 0.3rem;
}
.results {
  /* =========================
     SLIDER FRAME
  ========================= */
}
.results__frame {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
}
.results {
  /* =========================
     ARROWS
  ========================= */
}
.results__arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 60px;
  cursor: pointer;
  color: #1e2150;
  z-index: 10;
  transition: opacity 0.2s ease;
}
.results__arrow.left {
  left: -20px;
}
.results__arrow.right {
  right: -20px;
}
.results__arrow:hover {
  opacity: 0.65;
}
.results {
  /* =========================
     SLIDER
  ========================= */
}
.results__slider {
  overflow: hidden;
  touch-action: pan-y;
}
.results__track--simple {
  display: flex;
  gap: 2rem;
  will-change: opacity, transform;
  transition: opacity 0.35s ease, transform 0.35s ease;
}
.results__track--simple.is-animating.next {
  opacity: 0;
  transform: translateX(-28px);
}
.results__track--simple.is-animating.prev {
  opacity: 0;
  transform: translateX(28px);
}
.results {
  /* =========================
     RESULT CARD
  ========================= */
}
.results .result-card {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(33.333% - 1.33rem);
  max-width: 390px;
  min-height: 440px;
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
}
.results .result-card__img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 12px;
  margin-bottom: 1rem;
}
.results .result-card h4 {
  color: #1e2150;
  margin-bottom: 1rem;
  text-align: center;
}
.results .result-card .btn {
  margin-top: auto;
  width: 260px;
}
.results {
  /* =========================
     CARD HOVER (DESKTOP)
  ========================= */
}
@media (hover: hover) {
  .results .result-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 16px 36px rgba(0, 0, 0, 0.14), 0 0 0 2px rgba(44, 65, 144, 0.12);
  }
}
.results {
  /* =========================
     MODAL OVERLAY
  ========================= */
}
.results .modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}
.results {
  /* =========================
     MODAL WINDOW
  ========================= */
}
.results .modal {
  background: #fff;
  width: 100%;
  max-width: 640px;
  max-height: 90vh;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  animation: slideUp 0.3s ease;
}
.results {
  /* =========================
     MODAL HEADER
  ========================= */
}
.results .modalHeader {
  padding: 24px 28px;
  background: #f0f0f5;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.results .modalHeader h3 {
  font-size: 1.4rem;
  font-weight: 800;
  color: #1e2150;
  margin: 0;
}
.results .modalClose {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #1e2150;
  padding: 6px;
  line-height: 1;
  transition: transform 0.2s ease;
}
.results .modalClose:hover {
  transform: scale(1.1);
}
.results {
  /* =========================
     MODAL BODY
  ========================= */
}
.results .modalBody {
  text-align: left;
  padding: 28px;
  overflow-y: auto;
  line-height: 1.8;
  color: #111827;
  font-size: 1rem;
}
.results .modalBody p {
  margin-bottom: 1.2rem;
}
.results .modalBody strong {
  color: #1e2150;
  font-weight: 600;
}
.results {
  /* =========================
     RESPONSIVE
  ========================= */
}
@media (max-width: 992px) {
  .results .result-card {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 1rem);
  }
}
@media (max-width: 768px) {
  .results__arrow {
    display: none;
  }
  .results__track--simple {
    display: flex;
    gap: 1rem;
  }
  .results .result-card {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .results .modalHeader,
  .results .modalBody {
    padding: 20px;
  }
}

/* =========================
   MODAL ANIMATION
========================= */
@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
/* GLOBAL MODAL — Results */
.modalOverlay {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.modal {
  background: #fff;
  max-width: 640px;
  width: 100%;
  max-height: 90vh;
  border-radius: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);
}

/* ============================
   WRAPPER
============================ */
.feature-block {
  max-width: 1400px;
  margin: 0 auto;
}
@media (max-width: 768px) {
  .feature-block {
    padding: 0 30px;
  }
}
@media (max-width: 576px) {
  .feature-block {
    padding: 0 15px;
  }
}

/* ============================
   FEATURE SLIDER
============================ */
.feature-slider {
  display: flex;
  align-items: stretch;
  border-radius: 16px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 80px;
  /* IMAGE */
}
.feature-slider__image {
  flex: 0 0 520px;
  height: 520px;
  overflow: hidden;
}
.feature-slider__image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.feature-slider {
  /* CONTENT */
}
.feature-slider__content {
  flex: 1 1;
  background: #1e2150;
  color: #fff;
  padding: 40px 36px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 520px;
}
.feature-slider__content .feature-text-wrap {
  max-width: 520px;
  min-height: 160px; /* prevents jumping */
}
.feature-slider__content .feature-title {
  font-size: 26px;
  font-weight: 800;
  margin-bottom: 16px;
  min-height: 60px;
}
.feature-slider__content .feature-text {
  font-size: 14px;
  line-height: 1.7;
  opacity: 0.95;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.feature-slider__content .feature-nav {
  margin-top: auto;
  padding-top: 24px;
  display: flex;
  gap: 14px;
}
.feature-slider__content .feature-nav .nav-btn {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 2px solid #fff;
  background: transparent;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
  transition: 0.2s ease;
}
.feature-slider__content .feature-nav .nav-btn:hover {
  background: #fff;
  color: #1e2150;
}
.feature-slider {
  /* ============================
     TABLET
  ============================ */
}
@media (max-width: 992px) {
  .feature-slider {
    flex-direction: column;
  }
  .feature-slider__image {
    width: 100%;
    height: 320px;
  }
  .feature-slider__content {
    min-height: 340px;
    padding: 30px 24px;
    text-align: center;
    align-items: center;
  }
  .feature-slider__content .feature-text-wrap {
    max-width: 90%;
    min-height: 120px;
  }
  .feature-slider__content .feature-nav {
    justify-content: center;
  }
}
.feature-slider {
  /* ============================
     MOBILE
  ============================ */
}
@media (max-width: 576px) {
  .feature-slider__image {
    height: 240px;
  }
  .feature-slider__content {
    min-height: 300px;
    padding: 24px 20px;
  }
  .feature-slider__content .feature-title {
    font-size: 20px;
    min-height: 48px;
  }
  .feature-slider__content .feature-text {
    font-size: 13px;
  }
  .feature-slider__content .nav-btn {
    width: 38px;
    height: 38px;
  }
}

/* ============================
   CTA BANNER
============================ */
.feature-cta {
  position: relative;
  height: 220px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
}
.feature-cta__bg {
  position: absolute;
  inset: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  pointer-events: none;
}
.feature-cta::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(80% 80% at 80% 20%, rgba(36, 52, 109, 0.25), rgba(36, 52, 109, 0.05));
  pointer-events: none;
}
.feature-cta__content {
  position: relative;
  z-index: 2;
  height: 100%;
  padding: 0 60px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 14px;
}
.feature-cta__content .cta-title {
  color: #1e2150;
  font-size: 28px;
  font-weight: 800;
  max-width: 650px;
  text-align: right;
}
@media (max-width: 768px) {
  .feature-cta {
    height: 180px;
  }
  .feature-cta__content {
    padding: 0 40px;
  }
  .feature-cta__content .cta-title {
    font-size: 24px;
  }
}
@media (max-width: 576px) {
  .feature-cta {
    height: 200px;
  }
  .feature-cta__content {
    padding: 0 20px;
    align-items: center;
    text-align: center;
  }
  .feature-cta__content .cta-title {
    font-size: 18px;
    line-height: 1.4;
  }
}

/* 🌐 Blog Section */
.blog-section {
  max-width: 1400px;
  margin: 0 auto;
  padding: 100px 0;
  text-align: center;
  /* RESPONSIVE PADDING */
}
@media (max-width: 1200px) {
  .blog-section {
    padding: 80px 2rem;
  }
}
@media (max-width: 992px) {
  .blog-section {
    padding: 70px 1.5rem;
  }
}
@media (max-width: 768px) {
  .blog-section {
    padding: 60px 1rem;
  }
}
@media (max-width: 576px) {
  .blog-section {
    padding: 50px 0.75rem;
  }
}
@media (max-width: 480px) {
  .blog-section {
    padding: 40px 0.5rem;
  }
}
.blog-section {
  /* TITLE */
}
.blog-section .blog-title {
  font-size: clamp(1.4rem, 4vw, 2.2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: 2rem;
}
@media (max-width: 768px) {
  .blog-section .blog-title {
    font-size: clamp(1.3rem, 5vw, 1.9rem);
  }
}
@media (max-width: 576px) {
  .blog-section .blog-title {
    font-size: clamp(1.2rem, 6vw, 1.6rem);
    margin-bottom: 1rem;
  }
}
@media (max-width: 480px) {
  .blog-section .blog-title {
    font-size: clamp(1.1rem, 7vw, 1.4rem);
    margin-bottom: 0.5rem;
  }
}
.blog-section {
  /* GRID */
}
.blog-section .blog-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  justify-items: center;
  margin: 0 auto;
}
@media (max-width: 992px) {
  .blog-section .blog-container {
    gap: 2rem;
  }
}
@media (max-width: 768px) {
  .blog-section .blog-container {
    max-width: 600px;
    gap: 1.5rem;
  }
}
@media (max-width: 576px) {
  .blog-section .blog-container {
    grid-template-columns: 1fr;
    max-width: 400px;
  }
}
.blog-section {
  /* CARD */
}
.blog-section .blog-card {
  width: 100%;
  max-width: 350px;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.blog-section .blog-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);
}
.blog-section .blog-card img {
  width: 100%;
  height: 220px;
  object-fit: cover;
}
@media (max-width: 576px) {
  .blog-section .blog-card img {
    height: 180px;
  }
}
.blog-section .blog-card__content {
  padding: 1.5rem;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.blog-section .blog-card__content h3 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e2150;
  line-height: 1.3;
}
.blog-section .blog-card__content p {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.6;
  flex: 1 1;
}
.blog-section .blog-card__content .read-more {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: #1e2150;
  font-weight: 600;
  cursor: pointer;
  padding: 0.5rem 0;
  transition: color 0.2s ease, transform 0.2s ease;
}
.blog-section .blog-card__content .read-more__icon {
  transition: transform 0.2s ease;
}
.blog-section .blog-card__content .read-more:hover {
  color: rgb(27, 29.7, 72);
  transform: translateX(2px);
}
.blog-section .blog-card__content .read-more:hover .read-more__icon {
  transform: translateX(4px);
}

/* MODAL OVERLAY */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

/* MODAL */
.modal {
  background: #fff;
  border-radius: 12px;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}
.modal h3 {
  font-size: 1.2rem;
  color: #1e2150;
  margin-bottom: 1rem;
}
.modal p {
  font-size: 1rem;
  line-height: 1.7;
  color: #111827;
}

.contact {
  max-width: 1400px;
  margin: 0 auto;
  padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem);
  /* ---------- TITLE ---------- */
}
.contact__title {
  font-size: clamp(1.4rem, 5vw, 2.2rem);
  font-weight: 800;
  color: #1e2150;
  margin-bottom: clamp(1.5rem, 4vw, 2.5rem);
  text-align: center;
  line-height: 1.2;
}
@media (max-width: 768px) {
  .contact__title {
    font-size: clamp(1.3rem, 6vw, 1.9rem);
    margin-bottom: clamp(1.25rem, 3vw, 2rem);
  }
}
@media (max-width: 576px) {
  .contact__title {
    font-size: clamp(1.2rem, 7vw, 1.6rem);
    margin-bottom: clamp(1rem, 3vw, 1.5rem);
  }
}
.contact {
  /* ---------- GRID LAYOUT ---------- */
}
.contact__grid {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: clamp(1.5rem, 4vw, 2.5rem);
  align-items: start;
}
@media (max-width: 1024px) {
  .contact__grid {
    grid-template-columns: 1fr 0.7fr;
    gap: clamp(1.25rem, 3vw, 2rem);
  }
}
@media (max-width: 768px) {
  .contact__grid {
    grid-template-columns: 1fr;
    gap: clamp(2rem, 5vw, 3rem);
  }
}
@media (max-width: 576px) {
  .contact__grid {
    gap: clamp(1.5rem, 4vw, 2.5rem);
  }
}
.contact {
  /* ---------- FORM SECTION ---------- */
}
.contact__form {
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 2vw, 1rem);
}
.contact__form .input,
.contact__form .textarea {
  width: 100%;
  border: 1px solid #ddd;
  border-radius: clamp(6px, 1vw, 8px);
  padding: clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 16px);
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
  background: #fafafa;
}
.contact__form .input:focus,
.contact__form .textarea:focus {
  border-color: #1e2150;
  box-shadow: 0 0 0 3px rgba(36, 52, 109, 0.15);
  background: #fff;
}
@media (max-width: 576px) {
  .contact__form .input,
  .contact__form .textarea {
    font-size: clamp(0.85rem, 3vw, 0.95rem);
    padding: clamp(10px, 2vw, 12px) clamp(12px, 2.5vw, 14px);
    border-radius: 6px;
  }
}
@media (max-width: 480px) {
  .contact__form .input,
  .contact__form .textarea {
    font-size: 16px;
  }
}
.contact__form .textarea {
  min-height: clamp(120px, 20vw, 150px);
  resize: vertical;
  line-height: 1.5;
}
@media (max-width: 768px) {
  .contact__form .textarea {
    min-height: clamp(100px, 15vw, 120px);
  }
}
@media (max-width: 576px) {
  .contact__form .textarea {
    min-height: clamp(80px, 12vw, 100px);
    resize: none;
  }
}
.contact__form .contact__button-wrapper {
  display: flex;
  justify-content: center;
  margin-top: clamp(0.5rem, 2vw, 1rem);
}
.contact__form .contact__button-wrapper .contact__submit {
  border: 2px solid #1e2150;
  background: transparent;
  color: #1e2150;
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  font-weight: 600;
  padding: clamp(10px, 2vw, 12px) clamp(30px, 6vw, 40px);
  border-radius: 40px;
  cursor: pointer;
  transition: all 0.25s ease;
}
.contact__form .contact__button-wrapper .contact__submit:hover {
  background: #1e2150;
  color: white;
  transform: translateY(-2px);
}
@media (max-width: 576px) {
  .contact__form .contact__button-wrapper .contact__submit {
    width: 100%;
    font-size: clamp(0.85rem, 3vw, 0.95rem);
    padding: clamp(12px, 2.5vw, 14px) 0;
    border-radius: 8px;
    justify-content: center;
  }
}
.contact__form .form-status {
  text-align: center;
  margin-top: clamp(0.6rem, 2vw, 0.8rem);
  font-weight: 600;
  font-size: clamp(0.85rem, 2vw, 0.95rem);
}
.contact__form .form-status.ok {
  color: #18a957;
}
.contact__form .form-status.err {
  color: #d64545;
}
.contact {
  /* ---------- SOCIAL LINKS ---------- */
  /* ---------- SOCIAL ICONS ---------- */
}
.contact .contact__socials .social-icons {
  display: flex;
  gap: clamp(10px, 2vw, 16px);
}
.contact .contact__socials .social-icons a {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 1.5px solid rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1e2150;
  font-size: 1.2rem;
  transition: all 0.25s ease;
  background: #fff;
}
.contact .contact__socials .social-icons a:hover {
  background: #1e2150;
  color: #fff;
  transform: translateY(-3px);
  box-shadow: 0 8px 20px rgba(36, 52, 109, 0.25);
}
@media (max-width: 768px) {
  .contact .contact__socials .social-icons {
    justify-content: center;
  }
}
.contact {
  /* ---------- INFO SECTION ---------- */
}
.contact__info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  border-left: 1px solid rgba(0, 0, 0, 0.1);
  padding-left: clamp(1rem, 3vw, 2rem);
  gap: clamp(1rem, 2.5vw, 1.5rem);
}
@media (max-width: 1024px) {
  .contact__info {
    gap: clamp(0.8rem, 2vw, 1.2rem);
    padding-left: clamp(0.75rem, 2vw, 1.5rem);
  }
}
@media (max-width: 768px) {
  .contact__info {
    border-left: none;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    padding-left: 0;
    padding-top: clamp(1.5rem, 4vw, 2rem);
    align-items: center;
    text-align: center;
    gap: clamp(1.25rem, 3vw, 1.5rem);
  }
}
@media (max-width: 576px) {
  .contact__info {
    gap: clamp(1rem, 2.5vw, 1.25rem);
    padding-top: clamp(1rem, 3vw, 1.5rem);
  }
}
.contact__info .info-item h4 {
  font-size: clamp(0.9rem, 2.5vw, 1rem);
  color: #1e2150;
  margin-bottom: clamp(4px, 1vw, 6px);
  font-weight: 600;
}
@media (max-width: 576px) {
  .contact__info .info-item h4 {
    font-size: clamp(0.85rem, 3vw, 0.95rem);
  }
}
.contact__info .info-item a,
.contact__info .info-item p {
  color: #111827;
  text-decoration: none;
  font-size: clamp(0.85rem, 2.2vw, 1rem);
  line-height: 1.4;
}
@media (max-width: 576px) {
  .contact__info .info-item a,
  .contact__info .info-item p {
    font-size: clamp(0.8rem, 2.5vw, 0.9rem);
  }
}
.contact__info .info-item a:hover {
  color: #1e2150;
  text-decoration: underline;
}
.contact {
  /* ---------- RESPONSIVE PADDING ---------- */
}
@media (max-width: 1200px) {
  .contact {
    padding: clamp(1.5rem, 4vw, 3rem) clamp(1.5rem, 4vw, 2rem);
  }
}
@media (max-width: 768px) {
  .contact {
    padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 2.5vw, 1.5rem);
  }
}
@media (max-width: 576px) {
  .contact {
    padding: clamp(1rem, 2.5vw, 1.5rem) clamp(0.75rem, 2vw, 1rem);
  }
}
@media (max-width: 480px) {
  .contact {
    padding: clamp(0.75rem, 2vw, 1rem) clamp(0.5rem, 1.5vw, 0.75rem);
  }
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Noto Sans Armenian", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Helvetica Neue", sans-serif;
  background: #f9fafb;
  color: #111827;
  line-height: 1.6;
}

a {
  text-decoration: none;
  color: inherit;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/main.scss","webpack://./src/styles/_mixins.scss","webpack://./src/styles/_buttons.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/layout.scss","webpack://./src/styles/footer.scss","webpack://./src/styles/styleHomePage/navbar.scss","webpack://./src/styles/styleHomePage/heroSection.scss","webpack://./src/styles/styleHomePage/services.scss","webpack://./src/styles/styleHomePage/results.scss","webpack://./src/styles/styleHomePage/features.scss","webpack://./src/styles/styleHomePage/blog.scss","webpack://./src/styles/styleHomePage/contact.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACEhB;;8BAAA;AAsBA;;8BAAA;ACrBA;EACE,oBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WCkCW;EDjCX,oBAAA;EACA,kBCuCU;EDtCV,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,uBAAA;EACA,oGACQ;EAKR;;gCAAA;AFEF;AEEE;EAIE,cAAA;EACA,mBAAA;EACA,yBAAA;AFHJ;AEOI;EACE,0DAAA;AFLN;AESE;EACE,yBCtBU;EDuBV,cChBI;AHSR;AESI;EACE,oEAAA;AFPN;AEWE;EACE,yBC1BK;ED2BL,cCxBG;AHeP;AEWI;EACE,mEAAA;AFTN;AEaE;EACE,qBCzCS;ED0CT,cC1CS;AH+Bb;AEaI;EACE,yBC7CO;ED8CP,cCtCE;AH2BR;AEjDA;EAkEE;;gCAAA;AFZF;AEiBI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AFfN;AEkBI;EACE,0BAAA;AFhBN;AE/DA;EAmFE;;gCAAA;AFfF;AEmBE;EACE,gBChDS;EDiDT,qBC3ES;ED4ET,cC5ES;ED6ET,oBAAA;EACA,oBC5CW;ED6CX,eAAA;EACA,gBAAA;AFjBJ;AEmBI;EACE,mBCnFO;EDoFP,cC5EE;ED6EF,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AFjBN;AEoBI;EACE,yBC7FO;ED8FP,cCtFE;AHoER;AEoBM;EACE,0BAAA;AFlBR;;AI7FA;EACE,iBDgCU;EC/BV,cAAA;EACA,kBD+BiB;EC9BjB,mBD8BiB;EC7BjB,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBDuCU;ECtCV,0CD0Cc;AHsDhB;AI9FE;EACE,SAAA;EACA,eAAA;AJgGJ;AChGI;EGbJ;IAiBI,kBAAA;IACA,mBAAA;EJgGF;AACF;ACtGI;EGbJ;IAsBI,kBAAA;IACA,mBAAA;EJiGF;AACF;AC5GI;EGbJ;IA2BI,kBAAA;IACA,mBAAA;EJkGF;AACF;;AKhIA;EACE,WAAA;EACA,wBAAA;EACA,kBAAA;ALmIF;AKjIE;EACE,UAAA;EACA,mBAAA;EACA,YAAA;EACA,wCAAA;ALmIJ;AKhIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ALkIJ;AK/HE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;ALiIJ;AK/HI;EACE,YAAA;EACA,YAAA;EACA,mBAAA;ALiIN;AK9HI;EACE,gBAAA;EACA,cFjBO;EEkBP,iBAAA;ALgIN;AK5HE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,cFjBG;EEkBH,kBAAA;EACA,eAAA;EACA,uBAAA;AL8HJ;AK5HI;EACE,cFvBC;EEwBD,qBAAA;EACA,2BAAA;AL8HN;AK5HM;EACE,cFrCK;AHmKb;AK1HI;EACE,YAAA;AL4HN;;AKvHA,kBAAA;AACA;EACE;IACE,sBAAA;IACA,WAAA;EL0HF;AACF;AM5LA;EACE,kBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,iBAAA;AN8LF;AM5LE;EACE,qCAAA;EACA,0CAAA;EACA,2BAAA;AN8LJ;AMzMA;EAcE,kCAAA;AN8LF;AM7LE;EACE,iBHiBQ;EGhBR,cAAA;EACA,oDAAA;EACA,aAAA;EACA,yBAAA;EACA,mCAAA;EACA,gBAAA;AN+LJ;AM7LI;EATF;IAUI,uBAAA;ENgMJ;AACF;AM7LE;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,mCAAA;AN+LJ;AMjOA;EAqCE,6CAAA;AN+LF;AM9LE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;EACA,cHrBG;EGsBH,qBAAA;ANgMJ;AM7LE;EACE,aAAA;AN+LJ;AM5LE;EACE;IACE,aAAA;EN8LJ;EM3LE;IACE,aAAA;IACA,kCAAA;IACA,iCAAA;IACA,gBAAA;IACA,mBAAA;IACA,0BAAA;IACA,cHlDO;IGmDP,qBAAA;EN6LJ;AACF;AM/PA;EAqEE,sCAAA;AN6LF;AM5LE;EACE,gCAAA;AN8LJ;AM3LE;EACE,iBH1CQ;EG2CR,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;AN6LJ;AM7QA;EAmFE,+BAAA;AN6LF;AM5LE;EACE,gCAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AN8LJ;AM5LI;EANF;IAOI,gCAAA;IACA,+BAAA;EN+LJ;AACF;AM7LI;EAXF;IAYI,gCAAA;IACA,+BAAA;ENgMJ;AACF;AMlSA;EAqGE,+BAAA;ANgMF;AM/LE;EACE,aAAA;EACA,2BAAA;ANiMJ;AM/LI;EACE,kBAAA;EACA,mCAAA;EACA,cHtFC;EGuFD,qBAAA;EACA,gBAAA;EACA,2BAAA;EAEA,cAAA;ANgMN;AM/LM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,mBHnGD;EGoGC,kBAAA;EACA,sBAAA;ANiMR;AM9LM;EACE,cHzGD;AHySP;AM9LQ;EACE,WAAA;ANgMV;AMzNI;EA6BE,kBAAA;AN+LN;AM9LM;EACE,cHlHD;AHkTP;AM9LQ;EACE,WAAA;ANgMV;AMtOE;EA2CE,gBAAA;AN8LJ;AM7LI;EA5CF;IA6CI,eAAA;IACA,MAAA;IACA,OAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,sCAAA;IACA,2BAAA;IAEA,UAAA;IACA,oBAAA;IACA,4BAAA;IAEA,yBAAA;IACA,0BAAA;EN8LJ;EM5LI;IACE,UAAA;IACA,oBAAA;IACA,wBAAA;EN8LN;EM3LI;IACE,iCAAA;IACA,8BAAA;IAEA,yBAAA;EN4LN;EM3LM;IACE,YAAA;EN6LR;AACF;AMzLI;EAjFF;IAkFI,qCAAA;IACA,2BAAA;EN4LJ;EM1LI;IACE,iCAAA;EN4LN;AACF;AMzXA;EAiME,oCAAA;AN2LF;AM1LE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;EACA,8BAAA;AN4LJ;AM1LI;EACE,6BAAA;EACA,8BAAA;EACA,mBHjMO;EGkMP,kBAAA;EACA,yBAAA;AN4LN;AMxLM;EACE,4CAAA;AN0LR;AMvLM;EACE,UAAA;ANyLR;AMtLM;EACE,8CAAA;ANwLR;AMpLI;EAhCF;IAiCI,aAAA;ENuLJ;AACF;AMrLI;EApCF;IAqCI,2BAAA;ENwLJ;AACF;AMhaA;EA2OE,iDAAA;ANwLF;AMvLE;EACE;IACE,iCAAA;ENyLJ;AACF;AMtLE;EAlPF;IAmPI,gEAAA;ENyLF;EMvLE;IACE,yCAAA;ENyLJ;AACF;AMtLE;EA1PF;IA2PI,4BAAA;ENyLF;EMvLE;IACE,iBAAA;ENyLJ;EMtLE;IACE,cAAA;ENwLJ;EMrLE;IACE,eAAA;ENuLJ;AACF;AMpLE;EA1QF;IA2QI,gBAAA;ENuLF;EMrLE;IACE,cAAA;ENuLJ;AACF;;AOtcA;;2BAAA;AAGA;EACE,iBJ6BU;EI5BV,cAAA;EACA,aAAA;EACA,sBAAA;APycF;;AOtcA;;2BAAA;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2CAAA;APycF;;AOtcA;;2BAAA;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EAEA,UAAA;EACA,uCAAA;APwcF;AC5dI;EMYJ;IAWI,sBAAA;IACA,kBAAA;IACA,kBAAA;EPycF;AACF;;AOtcA;EACE,iEAAA;APycF;;AOtcA;EACE,iEAAA;APycF;;AOrcA;;2BAAA;AAGA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EAEA,UAAA;EACA,+DAAA;EACA,sBAAA;APucF;AOrcE;EACE,gBAAA;EACA,mBAAA;APucJ;AOpcE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;APscJ;;AOlcA;;2BAAA;AAGA;EACE,YAAA;APqcF;;AOlcA;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EAEA,UAAA;EACA,kEAAA;EACA,sBAAA;APocF;AOlcE;EACE,eAAA;EACA,YAAA;EACA,mBAAA;APocJ;ACthBI;EMsEJ;IAgBI,aAAA;EPocF;AACF;;AOjcA;;2BAAA;AAGA;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,cJpGW;EIqGX,YAAA;EACA,iBAAA;EACA,WAAA;APocF;AOlcE;EACE,UAAA;EACA,sCAAA;APocJ;;AOhcA;EACE,UAAA;APmcF;;AOhcA;EACE,WAAA;APmcF;;AOhcA;;2BAAA;AAGA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,eAAA;APmcF;;AOhcA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;APmcF;AOjcE;EACE,mBJ1IS;AH6kBb;;AO/bA;;2BAAA;AAGA;EACE;IACE,UAAA;IACA,uCAAA;EPkcF;EOhcA;IACE,UAAA;IACA,iCAAA;EPkcF;AACF;AO/bA;EACE;IACE,UAAA;IACA,wCAAA;EPicF;EO/bA;IACE,UAAA;IACA,iCAAA;EPicF;AACF;AO9bA;EACE;IACE,UAAA;IACA,2BAAA;EPgcF;EO9bA;IACE,UAAA;IACA,wBAAA;EPgcF;AACF;AO7bA;EACE;IACE,UAAA;IACA,uCAAA;EP+bF;EO7bA;IACE,UAAA;IACA,iCAAA;EP+bF;AACF;AO3bA;;2BAAA;AN/LI;EMoMF;IACE,gBAAA;IACA,mBAAA;EP4bF;EOzbA;IACE,8BAAA,EAAA,kBAAA;IACA,SAAA;IACA,kBAAA;IACA,kBAAA;IACA,eAAA;EP2bF;EOxbA;IACE,eAAA;IACA,UAAA;EP0bF;EOxbE;IACE,kBAAA;IACA,iBAAA;EP0bJ;EOvbE;IACE,eAAA;IACA,mBAAA;IACA,kBAAA;IACA,gBAAA;EPybJ;EOrbA,gDAAA;EACA;IACE,wBAAA;IACA,uBAAA;IACA,eAAA;IACA,UAAA;EPubF;EOrbE;IACE,WAAA;IACA,gBAAA;IACA,mBAAA;EPubJ;EOnbA,+BAAA;EACA;IACE,aAAA;EPqbF;AACF;AQprBA;EACE,mBL0BS;EKzBT,iCAAA;EACA,kBAAA;EAEA;;6BAAA;ARurBF;AQprBE;EACE,iBAAA;EACA,qCAAA;ARsrBJ;AQnrBE;EACE,mCAAA;EACA,gBAAA;EACA,cLHS;AHwrBb;AQrsBA;EAmBE;;6BAAA;ARurBF;AQprBE;EACE,kBAAA;EACA,iBAAA;EACA,cAAA;ARsrBJ;AQ/sBA;EA4BE;;6BAAA;ARwrBF;AQrrBE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;ARurBJ;AQlrBE;EACE,WAAA;ARorBJ;AQjrBE;EACE,YAAA;ARmrBJ;AQ3uBA;EA8DE,UAAA;ARgrBF;AQ/qBE;EACE,aAAA;EACA,2BAAA;EACA,uCAAA;EACA,+IACQ;ARgrBZ;AQpvBA;EAyEE,oBAAA;AR8qBF;AQ7qBE;EACE,UAAA;EACA,wCAAA;EACA,iBAAA;AR+qBJ;AQ5vBA;EAgFE,oBAAA;AR+qBF;AQ9qBE;EACE,UAAA;EACA,uCAAA;EACA,iBAAA;ARgrBJ;AQpwBA;EAuFE,2BAAA;ARgrBF;AQ/qBE;EACE,uDAAA;ARirBJ;AQ9qBE;EACE,sBAAA;ARgrBJ;AQ3qBE;EACE,aAAA;EACA,+BAAA;EACA,sBAAA;AR6qBJ;AQlxBA;EAyGE;;6BAAA;AR8qBF;AQxqBE;EACE,aAAA;EACA,2BAAA;AR0qBJ;AQ3xBA;EAoHE;;6BAAA;AR4qBF;AQzqBE;EACE,YAAA;EAAA,cAAA;EAAA,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;EAEA,iBAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,0CAAA;EACA,uDAAA;EACA,sBAAA;EAEA,UAAA;ARuqBJ;AQtqBI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,qBAAA;EACA,gCAAA;ARsqBN;AQpqBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;ARsqBR;AQlqBI;EACE,cLjJO;EKkJP,gBAAA;EACA,mBAAA;EACA,kBAAA;ARoqBN;AQlqBM;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBL/JK;EKgKL,4BAAA;ARoqBR;AQhqBI;EACE,WL1JO;EK2JP,gBAAA;EACA,YAAA;EPtJJ,gBAAA;EACA,oBAAA;EACA,qBOqJ6B;EPpJ7B,4BAAA;ADyzBF;AQlqBI;EACE,kBAAA;ARoqBN;AQ71BA;EA6LE;;6BAAA;ARqqBF;AQlqBE;EACE;IACE,4BAAA;IACA,iHACQ;ERmqBZ;EQ9pBE;IACE,oCAAA;ERgqBJ;EQ7pBE;IACE,UAAA;ER+pBJ;AACF;AQ92BA;EAkNE;;6BAAA;ARiqBF;ACv2BI;EO0MA;IACE,YAAA;IAAA,cAAA;IAAA,4BAAA;ERgqBJ;AACF;AC52BI;EOgNA;IACE,aAAA;ER+pBJ;EQ5pBE;IACE,aAAA;IACA,WAAA;ER8pBJ;AACF;ACr3BI;EO4NA;IACE,cAAA;IACA,gBAAA;ER4pBJ;EQ1pBE;IACE,gBAAA;IACA,mBAAA;ER4pBJ;EQ1pBE;IACE,WAAA;IACA,YAAA;IACA,eAAA;ER4pBJ;EQzpBE;IACE,SAAA;ER2pBJ;EQxpBE;IACE,UAAA;ER0pBJ;AACF;;ASv5BA;EACE,mBN2BS;EM1BT,kBAAA;EACA,iCAAA;EAEA;;6BAAA;AT25BF;ASx5BE;EACE,mCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AT05BJ;ASt5BE;EACE,iBAAA;EACA,gBAAA;EACA,cNLS;EMMT,qBAAA;ATw5BJ;ASr5BE;EACE,mCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;ATu5BJ;ASl7BA;EA+BE;;6BAAA;ATw5BF;ASr5BE;EACE,aAAA;EACA,uBAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;ATu5BJ;ASr5BI;EACE,iBAAA;EACA,WNlBO;AHy6Bb;ASp5BI;EACE,iBAAA;EACA,cNlCO;EMmCP,kBAAA;ATs5BN;ASv8BA;EAqDE;;6BAAA;ATu5BF;ASp5BE;EACE,kBAAA;EACA,iBNzBQ;EM0BR,cAAA;ATs5BJ;ASj9BA;EA8DE;;6BAAA;ATw5BF;ASr5BE;EACE,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;ATu5BJ;ASr5BI;EACE,WAAA;ATu5BN;ASp5BI;EACE,YAAA;ATs5BN;ASn5BI;EACE,aAAA;ATq5BN;AS3+BA;EA0FE;;6BAAA;ATs5BF;ASn5BE;EACE,gBAAA;EACA,mBAAA;ATq5BJ;ASl5BE;EACE,aAAA;EACA,SAAA;EACA,+BAAA;EACA,oDACQ;ATm5BZ;ASh5BI;EACE,UAAA;EACA,4BAAA;ATk5BN;AS/4BI;EACE,UAAA;EACA,2BAAA;ATi5BN;ASlgCA;EAqHE;;6BAAA;ATk5BF;AS/4BE;EACE,YAAA;EAAA,cAAA;EAAA,mCAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,0CAAA;EACA,uDAAA;AT+4BJ;AS74BI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;AT+4BN;AS54BI;EACE,cNlIO;EMmIP,mBAAA;EACA,kBAAA;AT84BN;AS34BI;EACE,gBAAA;EACA,YAAA;AT64BN;ASpiCA;EA2JE;;6BAAA;AT84BF;AS34BE;EACE;IACE,2BAAA;IACA,8EACQ;ET44BZ;AACF;AS/iCA;EAuKE;;6BAAA;AT64BF;AS14BE;EACE,eAAA;EACA,QAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;AT44BJ;AS/jCA;EAsLE;;6BAAA;AT84BF;AS34BE;EACE,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,2CAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;AT64BJ;AShlCA;EAsME;;6BAAA;AT+4BF;AS54BE;EACE,kBAAA;EACA,mBN9KK;EM+KL,4CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AT84BJ;AS54BI;EACE,iBAAA;EACA,gBAAA;EACA,cNtMO;EMuMP,SAAA;AT84BN;AS14BE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,cNhNS;EMiNT,YAAA;EACA,cAAA;EACA,+BAAA;AT44BJ;AS14BI;EACE,qBAAA;AT44BN;AShnCA;EAwOE;;6BAAA;AT64BF;AS14BE;EACE,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,cNzNG;EM0NH,eAAA;AT44BJ;AS14BI;EACE,qBAAA;AT44BN;ASz4BI;EACE,cN1OO;EM2OP,gBAAA;AT24BN;ASpoCA;EA6PE;;6BAAA;AT44BF;AC5nCI;EQoPA;IACE,YAAA;IAAA,cAAA;IAAA,4BAAA;ET24BJ;AACF;ACjoCI;EQ0PA;IACE,aAAA;ET04BJ;ESv4BE;IACE,aAAA;IACA,SAAA;ETy4BJ;ESr4BE;IACE,cAAA;IACA,eAAA;ETu4BJ;ESp4BE;;IAEE,aAAA;ETs4BJ;AACF;;ASj4BA;;2BAAA;AAGA;EACE;IACE,UAAA;IACA,uCAAA;ETo4BF;ESl4BA;IACE,UAAA;IACA,iCAAA;ETo4BF;AACF;ASl4BA,2BAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,iCAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;ATo4BF;;ASj4BA;EACE,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,2CAAA;ATo4BF;;AUtsCA;;8BAAA;AAIA;EACE,iBP6BU;EO5BV,cAAA;AVwsCF;AUtsCE;EAJF;IAKI,eAAA;EVysCF;AACF;AUvsCE;EARF;IASI,eAAA;EV0sCF;AACF;;AUtsCA;;8BAAA;AAIA;EACE,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,mBAAA;EAEA,UAAA;AVusCF;AUrsCE;EACE,eAAA;EACA,aAAA;EACA,gBAAA;AVusCJ;AUrsCI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;AVusCN;AU3tCA;EAyBE,YAAA;AVqsCF;AUnsCE;EACE,SAAA;EACA,mBPpCS;EOqCT,WAAA;EAEA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,8BAAA;EAEA,iBAAA;AVksCJ;AUhsCI;EACE,gBAAA;EACA,iBAAA,EAAA,qBAAA;AVksCN;AU/rCI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AVisCN;AU9rCI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EAEA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AV+rCN;AU5rCI;EACE,gBAAA;EACA,iBAAA;EAEA,aAAA;EACA,SAAA;AV6rCN;AU3rCM;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,WAAA;EAEA,eAAA;EACA,eAAA;EAEA,qBAAA;AVyrCR;AUvrCQ;EACE,gBAAA;EACA,cP9FG;AHuxCb;AUhxCA;EA8FE;;gCAAA;AVurCF;AUnrCE;EAlGF;IAoGI,sBAAA;EVqrCF;EUnrCE;IACE,WAAA;IACA,aAAA;EVqrCJ;EUlrCE;IACE,iBAAA;IACA,kBAAA;IAEA,kBAAA;IACA,mBAAA;EVmrCJ;EUjrCI;IACE,cAAA;IACA,iBAAA;EVmrCN;EUhrCI;IACE,uBAAA;EVkrCN;AACF;AU3yCA;EA+HE;;gCAAA;AVirCF;AU7qCE;EAEE;IACE,aAAA;EV8qCJ;EU3qCE;IACE,iBAAA;IACA,kBAAA;EV6qCJ;EU3qCI;IACE,eAAA;IACA,gBAAA;EV6qCN;EU1qCI;IACE,eAAA;EV4qCN;EUzqCI;IACE,WAAA;IACA,YAAA;EV2qCN;AACF;;AUnqCA;;8BAAA;AAIA;EACE,kBAAA;EACA,aAAA;EAEA,mBAAA;EACA,gBAAA;EAEA,0CAAA;AVmqCF;AUjqCE;EACE,kBAAA;EACA,QAAA;EAEA,yDAAA;EACA,sBAAA;EACA,2BAAA;EAEA,oBAAA;AViqCJ;AU9pCE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EAEA,iGAAA;EAMA,oBAAA;AV0pCJ;AUvpCE;EACE,kBAAA;EACA,UAAA;EAEA,YAAA;EAEA,eAAA;EAEA,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EAEA,SAAA;AVqpCJ;AUnpCI;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AVqpCN;AUhpCE;EA3DF;IA6DI,aAAA;EVkpCF;EUhpCE;IAEE,eAAA;EVipCJ;EU/oCI;IACE,eAAA;EVipCN;AACF;AU1oCE;EA5EF;IA8EI,aAAA;EV4oCF;EU1oCE;IAEE,eAAA;IAEA,mBAAA;IACA,kBAAA;EV0oCJ;EUxoCI;IACE,eAAA;IACA,gBAAA;EV0oCN;AACF;;AW75CA,oBAAA;AACA;EACE,iBR8BU;EQ7BV,cAAA;EACA,gBAAA;EACA,kBAAA;EAEA,uBAAA;AX+5CF;AC15CI;EUXJ;IAQI,kBAAA;EXi6CF;AACF;AC/5CI;EUXJ;IAYI,oBAAA;EXk6CF;AACF;ACp6CI;EUXJ;IAgBI,kBAAA;EXm6CF;AACF;ACz6CI;EUXJ;IAoBI,qBAAA;EXo6CF;AACF;AC96CI;EUXJ;IAwBI,oBAAA;EXq6CF;AACF;AW97CA;EA2BE,UAAA;AXs6CF;AWr6CE;EACE,qCAAA;EACA,gBAAA;EACA,cRnBS;EQoBT,mBRMS;AHi6Cb;AC57CI;EUiBF;IAOI,qCAAA;EXw6CJ;AACF;ACj8CI;EUiBF;IAWI,qCAAA;IACA,mBRHO;EH46CX;AACF;ACv8CI;EUiBF;IAgBI,qCAAA;IACA,qBRTO;EHm7CX;AACF;AWx9CA;EAiDE,SAAA;AX06CF;AWz6CE;EACE,aAAA;EACA,2DAAA;EACA,qBAAA;EACA,cAAA;AX26CJ;ACt9CI;EUuCF;IAOI,SAAA;EX46CJ;AACF;AC39CI;EUuCF;IAWI,gBAAA;IACA,WAAA;EX66CJ;AACF;ACj+CI;EUuCF;IAgBI,0BAAA;IACA,gBAAA;EX86CJ;AACF;AWl/CA;EAuEE,SAAA;AX86CF;AW76CE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBRhCQ;EQiCR,gBAAA;EACA,0CR7BY;EQ8BZ,aAAA;EACA,sBAAA;EACA,qDAAA;AX+6CJ;AW76CI;EACE,2BAAA;EACA,2CAAA;AX+6CN;AW56CI;EACE,WAAA;EACA,aAAA;EACA,iBAAA;AX86CN;AC9/CI;EU6EA;IAMI,aAAA;EX+6CN;AACF;AW56CI;EACE,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AX86CN;AW56CM;EACE,iBAAA;EACA,gBAAA;EACA,cRhGK;EQiGL,gBAAA;AX86CR;AW36CM;EACE,kBAAA;EACA,WR3FK;EQ4FL,gBAAA;EACA,SAAA;AX66CR;AW16CM;EACE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,cRlHK;EQmHL,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,gDAAA;AX46CR;AW16CQ;EACE,+BAAA;AX46CV;AWz6CQ;EACE,wBAAA;EACA,0BAAA;AX26CV;AWx6CQ;EACE,0BAAA;AX06CV;;AWn6CA,kBAAA;AACA;EACE,eAAA;EACA,QAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AXs6CF;;AWn6CA,UAAA;AACA;EACE,gBAAA;EACA,mBRvHU;EQwHV,aAAA;EACA,gBAAA;EACA,WAAA;EACA,2CAAA;AXs6CF;AWp6CE;EACE,iBAAA;EACA,cR/JS;EQgKT,mBAAA;AXs6CJ;AWn6CE;EACE,eAAA;EACA,gBAAA;EACA,cR7JG;AHkkDP;;AY1lDA;EACE,iBTiCU;EShCV,cAAA;EACA,sDAAA;EAEA,gCAAA;AZ4lDF;AY3lDE;EACE,qCAAA;EACA,gBAAA;EACA,cTMS;ESLT,yCAAA;EACA,kBAAA;EACA,gBAAA;AZ6lDJ;AY3lDI;EARF;IASI,qCAAA;IACA,wCAAA;EZ8lDJ;AACF;AY5lDI;EAbF;IAcI,qCAAA;IACA,uCAAA;EZ+lDJ;AACF;AYrnDA;EAyBE,sCAAA;AZ+lDF;AY9lDE;EACE,aAAA;EACA,kCAAA;EACA,+BAAA;EACA,kBAAA;AZgmDJ;AY9lDI;EANF;IAOI,gCAAA;IACA,8BAAA;EZimDJ;AACF;AY/lDI;EAXF;IAYI,0BAAA;IACA,2BAAA;EZkmDJ;AACF;AYhmDI;EAhBF;IAiBI,+BAAA;EZmmDJ;AACF;AY/oDA;EA+CE,uCAAA;AZmmDF;AYlmDE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AZomDJ;AYlmDI;;EAEE,WAAA;EACA,sBAAA;EACA,mCAAA;EACA,wDAAA;EACA,qCAAA;EACA,aAAA;EACA,8CAAA;EACA,mBAAA;AZomDN;AYlmDM;;EACE,qBTlDK;ESmDL,6CAAA;EACA,gBAAA;AZqmDR;AYlmDM;EAjBF;;IAkBI,uCAAA;IACA,wDAAA;IACA,kBAAA;EZsmDN;AACF;AYpmDM;EAvBF;;IAwBI,eAAA;EZwmDN;AACF;AYrmDI;EACE,qCAAA;EACA,gBAAA;EACA,gBAAA;AZumDN;AYrmDM;EALF;IAMI,qCAAA;EZwmDN;AACF;AYtmDM;EATF;IAUI,oCAAA;IACA,YAAA;EZymDN;AACF;AYtmDI;EACE,aAAA;EACA,uBAAA;EACA,oCAAA;AZwmDN;AYtmDM;EACE,yBAAA;EACA,uBAAA;EACA,cTzFK;ES0FL,qCAAA;EACA,gBAAA;EACA,sDAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AZwmDR;AYtmDQ;EACE,mBTlGG;ESmGH,YAAA;EACA,2BAAA;AZwmDV;AYrmDQ;EAjBF;IAkBI,WAAA;IACA,uCAAA;IACA,mCAAA;IACA,kBAAA;IACA,uBAAA;EZwmDR;AACF;AYnmDI;EACE,kBAAA;EACA,sCAAA;EACA,gBAAA;EACA,uCAAA;AZqmDN;AYnmDM;EACE,cAAA;AZqmDR;AYlmDM;EACE,cAAA;AZomDR;AYhvDA;EAgJE,uCAAA;EACA,uCAAA;AZmmDF;AYjmDI;EACE,aAAA;EACA,2BAAA;AZmmDN;AYjmDM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,cTjJK;ESkJL,iBAAA;EACA,0BAAA;EACA,gBAAA;AZkmDR;AYhmDQ;EACE,mBTvJG;ESwJH,WAAA;EACA,2BAAA;EACA,8CAAA;AZkmDV;AY9lDM;EA1BF;IA2BI,uBAAA;EZimDN;AACF;AYhxDA;EAoLE,uCAAA;AZ+lDF;AY9lDE;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,yCAAA;EACA,oCAAA;EACA,+BAAA;AZgmDJ;AY9lDI;EARF;IASI,+BAAA;IACA,yCAAA;EZimDJ;AACF;AY/lDI;EAbF;IAcI,iBAAA;IACA,wCAAA;IACA,eAAA;IACA,qCAAA;IACA,mBAAA;IACA,kBAAA;IACA,gCAAA;EZkmDJ;AACF;AYhmDI;EAvBF;IAwBI,gCAAA;IACA,qCAAA;EZmmDJ;AACF;AYhmDM;EACE,qCAAA;EACA,cTrMK;ESsML,mCAAA;EACA,gBAAA;AZkmDR;AYhmDQ;EANF;IAOI,uCAAA;EZmmDR;AACF;AYhmDM;;EAEE,cTvMD;ESwMC,qBAAA;EACA,sCAAA;EACA,gBAAA;AZkmDR;AYhmDQ;EAPF;;IAQI,uCAAA;EZomDR;AACF;AYjmDM;EACE,cT3NK;ES4NL,0BAAA;AZmmDR;AY90DA;EAgPE,6CAAA;AZimDF;AYhmDE;EAjPF;IAkPI,0DAAA;EZmmDF;AACF;AYjmDE;EArPF;IAsPI,6DAAA;EZomDF;AACF;AYlmDE;EAzPF;IA0PI,6DAAA;EZqmDF;AACF;AYnmDE;EA7PF;IA8PI,gEAAA;EZsmDF;AACF;;AAp1DA;EACE,SAAA;EACA,UAAA;EACA,sBAAA;AAu1DF;;AAn1DA;EACE,iJGxBU;EHyBV,mBGGS;EHFT,cGHK;EHIL,gBAAA;AAs1DF;;AAn1DA;EACE,qBAAA;EACA,cAAA;AAs1DF;;AAn1DA;EACE,gBAAA;EACA,SAAA;AAs1DF","sourcesContent":["// 1. Utilities\r\n@use \"./variables\" as v;\r\n@use \"./mixins\" as m;\r\n\r\n// 2. Base / Components\r\n@use \"./buttons\";\r\n@use \"./layout\";\r\n@use \"./footer\";\r\n\r\n// 3. Pages / Sections\r\n@use \"styleHomePage/navbar\";\r\n@use \"styleHomePage/heroSection\";\r\n@use \"styleHomePage/services\";\r\n@use \"styleHomePage/results\";\r\n@use \"styleHomePage/features\";\r\n@use \"styleHomePage/blog\";\r\n@use \"styleHomePage/contact\";\r\n\r\n// 4. Global reset\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n// ✅ ԱՅՍ ՏՈՂՆ Է ՖԻՔՍԸ\r\nbody {\r\n  font-family: v.$font-base;\r\n  background: v.$bg-light;\r\n  color: v.$dark;\r\n  line-height: 1.6;\r\n}\r\n\r\na {\r\n  text-decoration: none;\r\n  color: inherit;\r\n}\r\n\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-weight: 700;\r\n  margin: 0;\r\n}\r\n","@use \"./variables\" as v;\r\n\r\n/* ============================\r\n   BREAKPOINTS\r\n============================ */\r\n$breakpoints: (\r\n        xs: 480px,\r\n        sm: 576px,\r\n        md: 768px,\r\n        lg: 992px,\r\n        xl: 1200px,\r\n        xxl: 1400px\r\n);\r\n\r\n@mixin respond($bp) {\r\n  @if map-has-key($breakpoints, $bp) {\r\n    @media (max-width: map-get($breakpoints, $bp)) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @warn \"No breakpoint found: #{$bp}\";\r\n  }\r\n}\r\n\r\n/* ============================\r\n   HELPERS\r\n============================ */\r\n@mixin flex-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n@mixin truncate-text($lines: 1) {\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: $lines;\r\n  -webkit-box-orient: vertical;\r\n}\r\n","@use \"sass:color\";\r\n@use \"./variables\" as v;\r\n\r\n.btn {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: v.$spacing-sm;\r\n  padding: v.$spacing-sm v.$spacing-lg;\r\n  border-radius: v.$radius-sm;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  border: 2px solid transparent;\r\n  background: transparent;\r\n  transition:\r\n          background-color v.$transition-fast ease,\r\n          color v.$transition-fast ease,\r\n          border-color v.$transition-fast ease,\r\n          transform v.$transition-fast ease;\r\n\r\n  /* ============================\r\n     VARIANTS\r\n  ============================ */\r\n\r\n  &--primary {\r\n    //background-color: v.$brand-blue;\r\n    //color: v.$light;\r\n\r\n    color: #1e2150;\r\n    border-radius: 15px;\r\n    border: 2px solid #1e2150;\r\n\r\n\r\n\r\n    &:hover {\r\n      background-color: color.adjust(v.$brand-blue, $lightness: -8%);\r\n    }\r\n  }\r\n\r\n  &--secondary {\r\n    background-color: v.$secondary;\r\n    color: v.$light;\r\n\r\n    &:hover {\r\n      background-color: color.adjust(v.$secondary, $lightness: -8%);\r\n    }\r\n  }\r\n\r\n  &--accent {\r\n    background-color: v.$accent;\r\n    color: v.$dark;\r\n\r\n    &:hover {\r\n      background-color: color.adjust(v.$accent, $lightness: -8%);\r\n    }\r\n  }\r\n\r\n  &--outline {\r\n    border-color: v.$brand-blue;\r\n    color: v.$brand-blue;\r\n\r\n    &:hover {\r\n      background-color: v.$brand-blue;\r\n      color: v.$light;\r\n\r\n\r\n    }\r\n  }\r\n\r\n  /* ============================\r\n     ICON SUPPORT\r\n  ============================ */\r\n\r\n  &--with-icon {\r\n    .btn__icon {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      transition: transform v.$transition-fast ease;\r\n    }\r\n\r\n    &:hover .btn__icon {\r\n      transform: translateX(4px);\r\n    }\r\n  }\r\n\r\n  /* ============================\r\n     READ MORE CTA\r\n  ============================ */\r\n\r\n  &--read-more {\r\n    margin-top: v.$spacing-lg;\r\n    border-color: v.$brand-blue;\r\n    color: v.$brand-blue;\r\n    padding: v.$spacing-sm v.$spacing-lg;\r\n    border-radius: v.$radius-round;\r\n    font-size: 1rem;\r\n    min-width: 220px;\r\n\r\n    .btn__icon {\r\n      background: v.$brand-blue;\r\n      color: v.$light;\r\n      width: 32px;\r\n      height: 32px;\r\n      border-radius: 50%;\r\n      font-size: 1rem;\r\n      font-weight: 700;\r\n    }\r\n\r\n    &:hover {\r\n      background-color: v.$brand-blue;\r\n      color: v.$light;\r\n\r\n      .btn__icon {\r\n        transform: translateX(8px);\r\n      }\r\n    }\r\n  }\r\n}\r\n","// =========================\r\n// Typography\r\n// =========================\r\n$font-base: \"Noto Sans Armenian\",\r\n-apple-system,\r\nBlinkMacSystemFont,\r\n\"Segoe UI\",\r\nRoboto,\r\nOxygen,\r\nUbuntu,\r\nCantarell,\r\n\"Helvetica Neue\",\r\nsans-serif;\r\n\r\n// =========================\r\n// Brand Colors\r\n// =========================\r\n$brand-blue: #1e2150;\r\n$brand-green: #9eba44;\r\n\r\n// Base Colors\r\n$primary: $brand-blue;\r\n$secondary: $brand-green;\r\n$accent: #facc15;\r\n\r\n$light: #ffffff;\r\n$dark: #111827;\r\n$gray: #6b7280;\r\n$text-muted: #555;\r\n\r\n// Backgrounds\r\n$bg-light: #f9fafb;\r\n$bg-alt: #f0f0f5;\r\n$bg-gray: #f6f6f6;\r\n\r\n// Layout\r\n$max-width: 1400px;\r\n$layout-padding-x: 70px;\r\n\r\n// Spacing\r\n$spacing-xs: 0.25rem;\r\n$spacing-sm: 0.5rem;\r\n$spacing-md: 1rem;\r\n$spacing-lg: 2rem;\r\n$spacing-xl: 4rem;\r\n\r\n// Radius\r\n$radius-xs: 4px;\r\n$radius-sm: 8px;\r\n$radius-md: 12px;\r\n$radius-lg: 20px;\r\n$radius-round: 999px;\r\n\r\n// Shadows\r\n$shadow-medium: 0 4px 18px rgba(0, 0, 0, 0.15);\r\n\r\n// Transitions\r\n$transition-fast: 0.2s;\r\n$transition-normal: 0.3s;\r\n$transition-slow: 0.5s;\r\n","@use \"./variables\" as v;\r\n@use \"./mixins\" as m;\r\n\r\n.layout-container {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n  padding-left: v.$layout-padding-x;\r\n  padding-right: v.$layout-padding-x;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border-radius: v.$radius-lg;\r\n  box-shadow: v.$shadow-medium;\r\n\r\n  main {\r\n    flex: 1;\r\n    padding: v.$spacing-lg 0;\r\n  }\r\n\r\n  @include m.respond(xl) {\r\n    padding-left: 50px;\r\n    padding-right: 50px;\r\n  }\r\n\r\n  @include m.respond(md) {\r\n    padding-left: 30px;\r\n    padding-right: 30px;\r\n  }\r\n\r\n  @include m.respond(sm) {\r\n    padding-left: 15px;\r\n    padding-right: 15px;\r\n  }\r\n}\r\n","@use \"variables\" as v;\r\n\r\n.footer {\r\n  width: 100%;\r\n  padding: 2rem 0 1.5rem 0;\r\n  text-align: center;\r\n\r\n  &__divider {\r\n    width: 85%;\r\n    margin: 0 auto 2rem;\r\n    border: none;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.2);\r\n  }\r\n\r\n  &__content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 1rem;\r\n  }\r\n\r\n  &__logo {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.6rem;\r\n\r\n    img {\r\n      width: 200px;\r\n      height: 50px;\r\n      object-fit: contain;\r\n    }\r\n\r\n    .footer__brand {\r\n      font-weight: 800;\r\n      color: v.$brand-blue;\r\n      font-size: 1.1rem;\r\n    }\r\n  }\r\n\r\n  &__text {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.6rem;\r\n    color: v.$dark;\r\n    font-size: 0.95rem;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n\r\n    a {\r\n      color: v.$dark;\r\n      text-decoration: none;\r\n      transition: color 0.2s ease;\r\n\r\n      &:hover {\r\n        color: v.$brand-blue;\r\n      }\r\n    }\r\n\r\n    span {\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n}\r\n\r\n/* 🔹 Responsive */\r\n@media (max-width: 768px) {\r\n  .footer__text {\r\n    flex-direction: column;\r\n    gap: 0.3rem;\r\n\r\n  }\r\n\r\n\r\n}\r\n","@use \"../variables\" as v;\r\n@use \"sass:color\";\r\n\r\n.navbar {\r\n  position: relative;\r\n  width: 100%;\r\n  z-index: 3000;\r\n  background: transparent;\r\n  border-radius: 0 0 20px 20px;\r\n  overflow: visible;\r\n\r\n  &.scrolled {\r\n    background: rgba(200, 200, 200, 0.93);\r\n    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.25);\r\n    backdrop-filter: blur(10px);\r\n  }\r\n\r\n  /* ---------- TOP BAR ---------- */\r\n  &__top {\r\n    max-width: v.$max-width;\r\n    margin: 0 auto;\r\n    padding: clamp(4px, 1vw, 6px) clamp(15px, 3vw, 20px);\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    font-size: clamp(12px, 2.5vw, 14px);\r\n    font-weight: 600;\r\n\r\n    @media (max-width: 576px) {\r\n      justify-content: center;\r\n    }\r\n  }\r\n\r\n  .navbar__lang button {\r\n    border: none;\r\n    background: none;\r\n    cursor: pointer;\r\n    padding: clamp(4px, 1vw, 8px);\r\n    font-size: clamp(12px, 2.5vw, 14px);\r\n  }\r\n\r\n  /* ---------- PHONE BUTTON LOGIC ---------- */\r\n  .navbar__phone--desktop {\r\n    display: flex;\r\n    align-items: center;\r\n    font-weight: 600;\r\n    gap: clamp(6px, 1.5vw, 8px);\r\n    font-size: clamp(14px, 2.5vw, 16px);\r\n    color: v.$dark;\r\n    text-decoration: none;\r\n  }\r\n\r\n  .navbar__phone--mobile {\r\n    display: none;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .navbar__phone--desktop {\r\n      display: none;\r\n    }\r\n\r\n    .navbar__phone--mobile {\r\n      display: flex;\r\n      margin-top: clamp(15px, 3vw, 20px);\r\n      font-size: clamp(18px, 4vw, 20px);\r\n      font-weight: 700;\r\n      align-items: center;\r\n      gap: clamp(8px, 2vw, 10px);\r\n      color: v.$brand-blue;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  /* ---------- MAIN NAVBAR ---------- */\r\n  &__bottom {\r\n    padding: clamp(8px, 2vw, 10px) 0;\r\n  }\r\n\r\n  &__container {\r\n    max-width: v.$max-width;\r\n    margin: 0 auto;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    padding: 0 clamp(15px, 3vw, 20px);\r\n  }\r\n\r\n  /* ---------- LOGO ---------- */\r\n  &__logo img {\r\n    width: clamp(150px, 20vw, 200px);\r\n    height: clamp(45px, 8vw, 60px);\r\n    object-fit: contain;\r\n    cursor: pointer;\r\n\r\n    @media (max-width: 768px) {\r\n      width: clamp(120px, 25vw, 160px);\r\n      height: clamp(36px, 10vw, 48px);\r\n    }\r\n\r\n    @media (max-width: 480px) {\r\n      width: clamp(100px, 30vw, 140px);\r\n      height: clamp(30px, 12vw, 42px);\r\n    }\r\n  }\r\n\r\n  /* ---------- MENU ---------- */\r\n  &__menu {\r\n    display: flex;\r\n    gap: clamp(20px, 4vw, 30px);\r\n\r\n    a {\r\n      position: relative;\r\n      font-size: clamp(14px, 2.5vw, 16px);\r\n      color: v.$dark;\r\n      text-decoration: none;\r\n      font-weight: 500;\r\n      transition: color 0.3s ease;\r\n\r\n      /* underline */\r\n      &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        bottom: -8px;\r\n        width: 0%;\r\n        height: 2px;\r\n        background: v.$dark;\r\n        border-radius: 2px;\r\n        transition: 0.25s ease;\r\n      }\r\n\r\n      &:hover {\r\n        color:  v.$dark;\r\n\r\n        &::after {\r\n          width: 100%;\r\n        }\r\n      }\r\n\r\n      /* ✅ ACTIVE LINK */\r\n      &.active {\r\n        color: v.$dark;\r\n\r\n        &::after {\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n\r\n    /* MOBILE MENU */\r\n    @media (max-width: 992px) {\r\n      position: fixed;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100vw;\r\n      height: 100vh;\r\n      background: #ffffff;\r\n      display: flex;\r\n      flex-direction: column;\r\n      align-items: center;\r\n      padding-top: clamp(100px, 15vw, 120px);\r\n      gap: clamp(20px, 4vw, 25px);\r\n\r\n      opacity: 0;\r\n      pointer-events: none;\r\n      transform: translateY(-15px);\r\n\r\n      z-index: 99999 !important;\r\n      transition: all 0.35s ease;\r\n\r\n      &.open {\r\n        opacity: 1;\r\n        pointer-events: auto;\r\n        transform: translateY(0);\r\n      }\r\n\r\n      a {\r\n        font-size: clamp(18px, 5vw, 22px);\r\n        padding: clamp(8px, 2vw, 12px);\r\n\r\n        /* mobile underline fix */\r\n        &::after {\r\n          bottom: -4px;\r\n        }\r\n      }\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      padding-top: clamp(80px, 12vw, 100px);\r\n      gap: clamp(15px, 3vw, 20px);\r\n\r\n      a {\r\n        font-size: clamp(16px, 6vw, 20px);\r\n      }\r\n    }\r\n  }\r\n\r\n  /* ---------- HAMBURGER ---------- */\r\n  .hamburger {\r\n    display: none;\r\n    flex-direction: column;\r\n    gap: clamp(3px, 1vw, 5px);\r\n    border: none;\r\n    background: transparent;\r\n    cursor: pointer;\r\n    z-index: 100000 !important;\r\n    padding: clamp(8px, 2vw, 12px);\r\n\r\n    span {\r\n      width: clamp(24px, 4vw, 28px);\r\n      height: clamp(2px, 0.5vw, 3px);\r\n      background: v.$brand-blue;\r\n      border-radius: 2px;\r\n      transition: all 0.3s ease;\r\n    }\r\n\r\n    &.active {\r\n      span:nth-child(1) {\r\n        transform: rotate(45deg) translate(5px, 5px);\r\n      }\r\n\r\n      span:nth-child(2) {\r\n        opacity: 0;\r\n      }\r\n\r\n      span:nth-child(3) {\r\n        transform: rotate(-45deg) translate(7px, -6px);\r\n      }\r\n    }\r\n\r\n    @media (max-width: 992px) {\r\n      display: flex;\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      gap: clamp(2px, 0.8vw, 4px);\r\n    }\r\n  }\r\n\r\n  /* ---------- RESPONSIVE ADJUSTMENTS ---------- */\r\n  @media (max-width: 1024px) {\r\n    &__container {\r\n      padding: 0 clamp(10px, 2vw, 15px);\r\n    }\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    border-radius: 0 0 clamp(12px, 2vw, 16px) clamp(12px, 2vw, 16px);\r\n\r\n    &.scrolled {\r\n      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);\r\n    }\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    border-radius: 0 0 10px 10px;\r\n\r\n    &__top {\r\n      padding: 3px 10px;\r\n    }\r\n\r\n    &__bottom {\r\n      padding: 6px 0;\r\n    }\r\n\r\n    &__container {\r\n      padding: 0 10px;\r\n    }\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    border-radius: 0;\r\n\r\n    &__container {\r\n      padding: 0 8px;\r\n    }\r\n  }\r\n}\r\n","@use \"../variables\" as v;\r\n@use \"../mixins\" as m;\r\n\r\n/* =========================\r\n   WRAPPER\r\n========================= */\r\n.hero__wrapper {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* =========================\r\n   SLIDER CARD\r\n========================= */\r\n.hero__sliderCard {\r\n  position: relative;\r\n  background: #fff;\r\n  border-radius: 18px;\r\n  overflow: hidden;\r\n  min-height: 360px;\r\n  box-shadow: 0 14px 34px rgba(0, 0, 0, 0.08);\r\n}\r\n\r\n/* =========================\r\n   SLIDE ROW\r\n========================= */\r\n.hero__row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 3rem;\r\n  padding: 44px;\r\n  min-height: inherit;\r\n\r\n  opacity: 0;\r\n  transform: translateX(60px) scale(0.96);\r\n\r\n  @include m.respond(md) {\r\n    flex-direction: column;\r\n    text-align: center;\r\n    padding: 34px 24px;\r\n  }\r\n}\r\n\r\n.hero__row--next {\r\n  animation: slideNext 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;\r\n}\r\n\r\n.hero__row--prev {\r\n  animation: slidePrev 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;\r\n}\r\n\r\n\r\n/* =========================\r\n   CONTENT\r\n========================= */\r\n.hero__content {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n\r\n  opacity: 0;\r\n  animation: fadeUp 0.65s cubic-bezier(0.22, 1, 0.36, 1) forwards;\r\n  animation-delay: 0.25s;\r\n\r\n  h1 {\r\n    font-weight: 700;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  p {\r\n    max-width: 520px;\r\n    margin-bottom: 2rem;\r\n    line-height: 1.6;\r\n  }\r\n}\r\n\r\n/* =========================\r\n   IMAGE\r\n========================= */\r\n.btn1 {\r\n  width: 300px;\r\n}\r\n\r\n.hero__image {\r\n  flex: 1;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n\r\n  opacity: 0;\r\n  animation: imageFloat 0.7s cubic-bezier(0.22, 1, 0.36, 1) forwards;\r\n  animation-delay: 0.35s;\r\n\r\n  img {\r\n    max-width: 100%;\r\n    height: auto;\r\n    border-radius: 20px;\r\n  }\r\n\r\n  @include m.respond(md) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* =========================\r\n   ARROWS\r\n========================= */\r\n.hero__arrow {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  font-size: 60px;\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: v.$brand-blue;\r\n  opacity: 0.5;\r\n  transition: 0.25s;\r\n  z-index: 10;\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n    transform: translateY(-50%) scale(1.1);\r\n  }\r\n}\r\n\r\n.hero__arrow--left {\r\n  left: 14px;\r\n}\r\n\r\n.hero__arrow--right {\r\n  right: 14px;\r\n}\r\n\r\n/* =========================\r\n   DOTS\r\n========================= */\r\n.hero__dots {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 10px;\r\n  padding: 18px 0;\r\n}\r\n\r\n.hero__dot {\r\n  width: 10px;\r\n  height: 10px;\r\n  border-radius: 50%;\r\n  border: none;\r\n  background: #ccc;\r\n  cursor: pointer;\r\n\r\n  &.active {\r\n    background: v.$brand-blue;\r\n  }\r\n}\r\n\r\n/* =========================\r\n   ANIMATIONS\r\n========================= */\r\n@keyframes slideNext {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(60px) scale(0.96);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes slidePrev {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(-60px) scale(0.96);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes fadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(18px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes imageFloat {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(40px) scale(0.94);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0) scale(1);\r\n  }\r\n}\r\n\r\n\r\n/* =========================\r\n   MOBILE HERO FIX\r\n========================= */\r\n@include m.respond(md) {\r\n\r\n  .hero__sliderCard {\r\n    min-height: auto;\r\n    border-radius: 14px;\r\n  }\r\n\r\n  .hero__row {\r\n    flex-direction: column-reverse; /* ⬅️ image վերև */\r\n    gap: 18px;\r\n    padding: 22px 18px;\r\n    text-align: center;\r\n    transform: none;\r\n  }\r\n\r\n  .hero__content {\r\n    animation: none;\r\n    opacity: 1;\r\n\r\n    h1 {\r\n      font-size: 1.45rem;\r\n      line-height: 1.25;\r\n    }\r\n\r\n    p {\r\n      max-width: 100%;\r\n      margin-bottom: 18px;\r\n      font-size: 0.95rem;\r\n      line-height: 1.6;\r\n    }\r\n  }\r\n\r\n  /* 👇 ամենակարևորը — նկարը այլևս չի անհետանում */\r\n  .hero__image {\r\n    display: flex !important;\r\n    justify-content: center;\r\n    animation: none;\r\n    opacity: 1;\r\n\r\n    img {\r\n      width: 100%;\r\n      max-width: 320px;\r\n      border-radius: 16px;\r\n    }\r\n  }\r\n\r\n  /* arrows mobile-ում պետք չեն */\r\n  .hero__arrow {\r\n    display: none;\r\n  }\r\n}\r\n","@use \"sass:color\";\r\n@use \"../mixins\" as m;\r\n@use \"../variables\" as v;\r\n\r\n.services {\r\n  background: v.$bg-light;\r\n  padding: clamp(3rem, 8vw, 5rem) 0;\r\n  text-align: center;\r\n\r\n  /* =========================\r\n     HEADER\r\n  ========================= */\r\n  &__header {\r\n    max-width: 1260px;\r\n    margin: 0 auto clamp(2rem, 6vw, 3rem);\r\n  }\r\n\r\n  &__title {\r\n    font-size: clamp(1.8rem, 6vw, 3rem);\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n  }\r\n\r\n  /* =========================\r\n     FRAME (ARROWS LIVE HERE)\r\n  ========================= */\r\n  &__frame {\r\n    position: relative;\r\n    max-width: 1260px;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  /* =========================\r\n     ARROWS\r\n  ========================= */\r\n  &__arrow {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    height: 44px;\r\n    border: none;\r\n    background: none;\r\n    cursor: pointer;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 60px;\r\n    line-height: 1;\r\n    color: #1e2150;\r\n    z-index: 10;\r\n    transition: opacity 0.2s ease;\r\n\r\n\r\n  }\r\n\r\n  &__arrow--left {\r\n    left: -22px;\r\n  }\r\n\r\n  &__arrow--right {\r\n    right: -22px;\r\n  }\r\n\r\n  .services__container {\r\n  }\r\n\r\n  /* TRACK */\r\n  .services__track--simple {\r\n    display: flex;\r\n    gap: clamp(1rem, 3vw, 2rem);\r\n    will-change: opacity, transform, filter;\r\n    transition:\r\n            opacity 0.45s cubic-bezier(0.4, 0, 0.2, 1),\r\n            transform 0.45s cubic-bezier(0.4, 0, 0.2, 1),\r\n            filter 0.45s cubic-bezier(0.4, 0, 0.2, 1);\r\n  }\r\n\r\n  /* NEXT (աջից ձախ) */\r\n  .services__track--simple.is-animating.next {\r\n    opacity: 0;\r\n    transform: translateX(-34px) scale(0.96);\r\n    filter: blur(2px);\r\n  }\r\n\r\n  /* PREV (ձախից աջ) */\r\n  .services__track--simple.is-animating.prev {\r\n    opacity: 0;\r\n    transform: translateX(34px) scale(0.96);\r\n    filter: blur(2px);\r\n  }\r\n\r\n  /* CARDS — soft breathing */\r\n  .services__track--simple .card {\r\n    transition: transform 0.45s ease, box-shadow 0.45s ease;\r\n  }\r\n\r\n  .services__track--simple.is-animating .card {\r\n    transform: scale(0.97);\r\n  }\r\n\r\n\r\n\r\n  .services__track {\r\n    display: flex;\r\n    transition: transform 0.6s ease;\r\n    will-change: transform;\r\n  }\r\n\r\n\r\n  /* =========================\r\n     SLIDER CONTAINER\r\n  ========================= */\r\n  &__container {\r\n  }\r\n\r\n  &__track {\r\n    display: flex;\r\n    gap: clamp(1rem, 3vw, 2rem);\r\n  }\r\n\r\n  /* =========================\r\n     CARD\r\n  ========================= */\r\n  .card {\r\n    flex: 0 0 calc(33.333% - 1.333rem);\r\n    background: #fff;\r\n    border-radius: 16px;\r\n    padding: 2.2rem 1.6rem 2.4rem;\r\n\r\n    min-height: 420px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n\r\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\r\n    transition: transform 0.35s ease, box-shadow 0.35s ease;\r\n    will-change: transform;\r\n\r\n    /* badge */\r\n    &__badge {\r\n      width: 110px;\r\n      height: 110px;\r\n      border-radius: 50%;\r\n      background: #fff;\r\n\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n\r\n      margin-bottom: 1.2rem;\r\n      transition: transform 0.35s ease;\r\n\r\n      img {\r\n        width: 82px;\r\n        height: 82px;\r\n        object-fit: contain;\r\n      }\r\n    }\r\n\r\n    h3 {\r\n      color: v.$brand-blue;\r\n      font-weight: 700;\r\n      margin-bottom: 1rem;\r\n      position: relative;\r\n\r\n      &::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 50%;\r\n        bottom: -10px;\r\n        transform: translateX(-50%);\r\n        width: 0%;\r\n        height: 2px;\r\n        border-radius: 2px;\r\n        background: v.$brand-blue;\r\n        transition: width 0.35s ease;\r\n      }\r\n    }\r\n\r\n    p {\r\n      color: v.$text-muted;\r\n      line-height: 1.6;\r\n      flex-grow: 1;\r\n      @include m.truncate-text(4);\r\n    }\r\n\r\n    .btn {\r\n      margin-top: 1.4rem;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     HOVER (DESKTOP ONLY)\r\n  ========================= */\r\n  @media (hover: hover) {\r\n    .card:hover {\r\n      transform: translateY(-10px);\r\n      box-shadow:\r\n              0 18px 40px rgba(0, 0, 0, 0.14),\r\n              0 0 0 2px rgba(44, 65, 144, 0.12),\r\n              0 0 24px rgba(158, 186, 68, 0.18);\r\n    }\r\n\r\n    .card:hover .card__badge {\r\n      transform: rotate(-4deg) scale(1.05);\r\n    }\r\n\r\n    .card:hover h3::after {\r\n      width: 55%;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     RESPONSIVE\r\n  ========================= */\r\n  @include m.respond(lg) {\r\n    .card {\r\n      flex: 0 0 calc(50% - 1rem);\r\n    }\r\n  }\r\n\r\n  @include m.respond(md) {\r\n    &__arrow {\r\n      display: none;\r\n    }\r\n\r\n    .services__track--simple {\r\n      display: flex;\r\n      gap: 1.2rem;\r\n    }\r\n  }\r\n\r\n\r\n  @include m.respond(md) {\r\n    .card {\r\n      flex: 0 0 100%;\r\n      min-height: auto;\r\n    }\r\n    .services__container {\r\n      overflow: hidden;\r\n      touch-action: pan-y;\r\n    }\r\n    &__arrow {\r\n      width: 38px;\r\n      height: 38px;\r\n      font-size: 26px;\r\n    }\r\n\r\n    &__arrow--left {\r\n      left: 6px;\r\n    }\r\n\r\n    &__arrow--right {\r\n      right: 6px;\r\n    }\r\n  }\r\n}\r\n","@use \"../variables\" as v;\r\n@use \"../mixins\" as m;\r\n\r\n.results {\r\n  background: v.$bg-light;\r\n  text-align: center;\r\n  padding: clamp(3rem, 8vw, 5rem) 0;\r\n\r\n  /* =========================\r\n     TITLES\r\n  ========================= */\r\n  &__title {\r\n    font-size: clamp(1.4rem, 4vw, 2rem);\r\n    font-weight: 800;\r\n    color: #1e2150;\r\n    margin-bottom: 3rem;\r\n\r\n  }\r\n\r\n  &__subtitle {\r\n    font-size: 1.2rem;\r\n    font-weight: 600;\r\n    color: v.$brand-blue;\r\n    margin-bottom: 2.5rem;\r\n  }\r\n\r\n  .results__subtitle{\r\n    font-size: clamp(1.4rem, 4vw, 2rem);\r\n    font-weight: 800;\r\n    color: #1e2150;\r\n    margin-bottom: 3rem;\r\n\r\n  }\r\n\r\n  /* =========================\r\n     STATS\r\n  ========================= */\r\n  &__stats {\r\n    display: flex;\r\n    justify-content: center;\r\n    gap: clamp(3rem, 10vw, 8rem);\r\n    flex-wrap: wrap;\r\n    margin-bottom: 3rem;\r\n\r\n    p {\r\n      font-size: 0.9rem;\r\n      color: v.$text-muted;\r\n    }\r\n\r\n    h3 {\r\n      font-size: 1.6rem;\r\n      color: v.$brand-blue;\r\n      margin-top: 0.3rem;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     SLIDER FRAME\r\n  ========================= */\r\n  &__frame {\r\n    position: relative;\r\n    max-width: v.$max-width;\r\n    margin: 0 auto;\r\n  }\r\n\r\n  /* =========================\r\n     ARROWS\r\n  ========================= */\r\n  &__arrow {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    border: none;\r\n    font-size: 60px;\r\n    cursor: pointer;\r\n    color: #1e2150;\r\n    z-index: 10;\r\n    transition: opacity 0.2s ease;\r\n\r\n    &.left {\r\n      left: -20px;\r\n    }\r\n\r\n    &.right {\r\n      right: -20px;\r\n    }\r\n\r\n    &:hover {\r\n      opacity: 0.65;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     SLIDER\r\n  ========================= */\r\n  &__slider {\r\n    overflow: hidden;\r\n    touch-action: pan-y;\r\n  }\r\n\r\n  &__track--simple {\r\n    display: flex;\r\n    gap: 2rem;\r\n    will-change: opacity, transform;\r\n    transition:\r\n            opacity 0.35s ease,\r\n            transform 0.35s ease;\r\n\r\n    &.is-animating.next {\r\n      opacity: 0;\r\n      transform: translateX(-28px);\r\n    }\r\n\r\n    &.is-animating.prev {\r\n      opacity: 0;\r\n      transform: translateX(28px);\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     RESULT CARD\r\n  ========================= */\r\n  .result-card {\r\n    flex: 0 0 calc(33.333% - 1.33rem);\r\n    max-width: 390px;\r\n    min-height: 440px;\r\n    background: #fff;\r\n    border-radius: 16px;\r\n    padding: 1.5rem;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n\r\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);\r\n    transition: transform 0.35s ease, box-shadow 0.35s ease;\r\n\r\n    &__img {\r\n      width: 100%;\r\n      height: 220px;\r\n      object-fit: cover;\r\n      border-radius: 12px;\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    h4 {\r\n      color: v.$brand-blue;\r\n      margin-bottom: 1rem;\r\n      text-align: center;\r\n    }\r\n\r\n    .btn {\r\n      margin-top: auto;\r\n      width: 260px;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     CARD HOVER (DESKTOP)\r\n  ========================= */\r\n  @media (hover: hover) {\r\n    .result-card:hover {\r\n      transform: translateY(-8px);\r\n      box-shadow:\r\n              0 16px 36px rgba(0, 0, 0, 0.14),\r\n              0 0 0 2px rgba(44, 65, 144, 0.12);\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     MODAL OVERLAY\r\n  ========================= */\r\n  .modalOverlay {\r\n    position: fixed;\r\n    inset: 0;\r\n    background: rgba(17, 24, 39, 0.6);\r\n    backdrop-filter: blur(4px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    z-index: 1000;\r\n    padding: 1rem;\r\n  }\r\n\r\n  /* =========================\r\n     MODAL WINDOW\r\n  ========================= */\r\n  .modal {\r\n    background: #fff;\r\n    width: 100%;\r\n    max-width: 640px;\r\n    max-height: 90vh;\r\n    border-radius: 16px;\r\n    overflow: hidden;\r\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\r\n    display: flex;\r\n    flex-direction: column;\r\n    animation: slideUp 0.3s ease;\r\n  }\r\n\r\n  /* =========================\r\n     MODAL HEADER\r\n  ========================= */\r\n  .modalHeader {\r\n    padding: 24px 28px;\r\n    background: v.$bg-alt;\r\n    border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n\r\n    h3 {\r\n      font-size: 1.4rem;\r\n      font-weight: 800;\r\n      color: v.$brand-blue;\r\n      margin: 0;\r\n    }\r\n  }\r\n\r\n  .modalClose {\r\n    background: none;\r\n    border: none;\r\n    font-size: 28px;\r\n    cursor: pointer;\r\n    color: v.$brand-blue;\r\n    padding: 6px;\r\n    line-height: 1;\r\n    transition: transform 0.2s ease;\r\n\r\n    &:hover {\r\n      transform: scale(1.1);\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     MODAL BODY\r\n  ========================= */\r\n  .modalBody {\r\n    text-align: left;\r\n    padding: 28px;\r\n    overflow-y: auto;\r\n    line-height: 1.8;\r\n    color: v.$dark;\r\n    font-size: 1rem;\r\n\r\n    p {\r\n      margin-bottom: 1.2rem;\r\n    }\r\n\r\n    strong {\r\n      color: v.$brand-blue;\r\n      font-weight: 600;\r\n    }\r\n  }\r\n\r\n  /* =========================\r\n     RESPONSIVE\r\n  ========================= */\r\n  @include m.respond(lg) {\r\n    .result-card {\r\n      flex: 0 0 calc(50% - 1rem);\r\n    }\r\n  }\r\n\r\n  @include m.respond(md) {\r\n    &__arrow {\r\n      display: none;\r\n    }\r\n\r\n    &__track--simple {\r\n      display: flex;\r\n      gap: 1rem;\r\n    }\r\n\r\n\r\n    .result-card {\r\n      flex: 0 0 100%;\r\n      max-width: 100%;\r\n    }\r\n\r\n    .modalHeader,\r\n    .modalBody {\r\n      padding: 20px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n/* =========================\r\n   MODAL ANIMATION\r\n========================= */\r\n@keyframes slideUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px) scale(0.96);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n/* GLOBAL MODAL — Results */\r\n.modalOverlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(17, 24, 39, 0.6);\r\n  backdrop-filter: blur(4px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n  padding: 1rem;\r\n}\r\n\r\n.modal {\r\n  background: #fff;\r\n  max-width: 640px;\r\n  width: 100%;\r\n  max-height: 90vh;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.25);\r\n}\r\n","@use \"../variables\" as v;\r\n\r\n/* ============================\r\n   WRAPPER\r\n============================ */\r\n\r\n.feature-block {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n\r\n  @media (max-width: 768px) {\r\n    padding: 0 30px;\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    padding: 0 15px;\r\n  }\r\n}\r\n\r\n\r\n/* ============================\r\n   FEATURE SLIDER\r\n============================ */\r\n\r\n.feature-slider {\r\n  display: flex;\r\n  align-items: stretch;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  box-shadow: 0 6px 16px rgba(0,0,0,.08);\r\n  margin-bottom: 80px;\r\n\r\n  /* IMAGE */\r\n\r\n  &__image {\r\n    flex: 0 0 520px;\r\n    height: 520px;\r\n    overflow: hidden;\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: cover;\r\n      display: block;\r\n    }\r\n  }\r\n\r\n\r\n  /* CONTENT */\r\n\r\n  &__content {\r\n    flex: 1;\r\n    background: v.$brand-blue;\r\n    color: #fff;\r\n\r\n    padding: 40px 36px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n\r\n    min-height: 520px;\r\n\r\n    .feature-text-wrap {\r\n      max-width: 520px;\r\n      min-height: 160px; /* prevents jumping */\r\n    }\r\n\r\n    .feature-title {\r\n      font-size: 26px;\r\n      font-weight: 800;\r\n      margin-bottom: 16px;\r\n      min-height: 60px;\r\n    }\r\n\r\n    .feature-text {\r\n      font-size: 14px;\r\n      line-height: 1.7;\r\n      opacity: .95;\r\n\r\n      display: -webkit-box;\r\n      -webkit-line-clamp: 4;\r\n      -webkit-box-orient: vertical;\r\n      overflow: hidden;\r\n    }\r\n\r\n    .feature-nav {\r\n      margin-top: auto;\r\n      padding-top: 24px;\r\n\r\n      display: flex;\r\n      gap: 14px;\r\n\r\n      .nav-btn {\r\n        width: 44px;\r\n        height: 44px;\r\n\r\n        border-radius: 50%;\r\n        border: 2px solid #fff;\r\n\r\n        background: transparent;\r\n        color: #fff;\r\n\r\n        font-size: 18px;\r\n        cursor: pointer;\r\n\r\n        transition: .2s ease;\r\n\r\n        &:hover {\r\n          background: #fff;\r\n          color: v.$brand-blue;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  /* ============================\r\n     TABLET\r\n  ============================ */\r\n\r\n  @media (max-width: 992px) {\r\n\r\n    flex-direction: column;\r\n\r\n    &__image {\r\n      width: 100%;\r\n      height: 320px;\r\n    }\r\n\r\n    &__content {\r\n      min-height: 340px;\r\n      padding: 30px 24px;\r\n\r\n      text-align: center;\r\n      align-items: center;\r\n\r\n      .feature-text-wrap {\r\n        max-width: 90%;\r\n        min-height: 120px;\r\n      }\r\n\r\n      .feature-nav {\r\n        justify-content: center;\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n\r\n  /* ============================\r\n     MOBILE\r\n  ============================ */\r\n\r\n  @media (max-width: 576px) {\r\n\r\n    &__image {\r\n      height: 240px;\r\n    }\r\n\r\n    &__content {\r\n      min-height: 300px;\r\n      padding: 24px 20px;\r\n\r\n      .feature-title {\r\n        font-size: 20px;\r\n        min-height: 48px;\r\n      }\r\n\r\n      .feature-text {\r\n        font-size: 13px;\r\n      }\r\n\r\n      .nav-btn {\r\n        width: 38px;\r\n        height: 38px;\r\n      }\r\n    }\r\n\r\n  }\r\n\r\n}\r\n\r\n\r\n/* ============================\r\n   CTA BANNER\r\n============================ */\r\n\r\n.feature-cta {\r\n  position: relative;\r\n  height: 220px;\r\n\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n\r\n  box-shadow: 0 6px 16px rgba(0,0,0,.06);\r\n\r\n  &__bg {\r\n    position: absolute;\r\n    inset: 0;\r\n\r\n    background-image: url(\"../../Img/shutterstock_2416028885 (1).png\");\r\n    background-size: cover;\r\n    background-position: center;\r\n\r\n    pointer-events: none;\r\n  }\r\n\r\n  &::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    inset: 0;\r\n\r\n    background: radial-gradient(\r\n                    80% 80% at 80% 20%,\r\n                    rgba(36,52,109,.25),\r\n                    rgba(36,52,109,.05)\r\n    );\r\n\r\n    pointer-events: none;\r\n  }\r\n\r\n  &__content {\r\n    position: relative;\r\n    z-index: 2;\r\n\r\n    height: 100%;\r\n\r\n    padding: 0 60px;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n    justify-content: center;\r\n\r\n    gap: 14px;\r\n\r\n    .cta-title {\r\n      color: #1e2150;\r\n      font-size: 28px;\r\n      font-weight: 800;\r\n      max-width: 650px;\r\n      text-align: right;\r\n    }\r\n  }\r\n\r\n\r\n  @media (max-width: 768px) {\r\n\r\n    height: 180px;\r\n\r\n    &__content {\r\n\r\n      padding: 0 40px;\r\n\r\n      .cta-title {\r\n        font-size: 24px;\r\n      }\r\n\r\n    }\r\n\r\n  }\r\n\r\n\r\n  @media (max-width: 576px) {\r\n\r\n    height: 200px;\r\n\r\n    &__content {\r\n\r\n      padding: 0 20px;\r\n\r\n      align-items: center;\r\n      text-align: center;\r\n\r\n      .cta-title {\r\n        font-size: 18px;\r\n        line-height: 1.4;\r\n      }\r\n\r\n    }\r\n\r\n  }\r\n\r\n}","@use \"sass:color\";\r\n@use \"../mixins\" as m;\r\n@use \"../variables\" as v;\r\n\r\n/* 🌐 Blog Section */\r\n.blog-section {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n  padding: 100px 0;\r\n  text-align: center;\r\n\r\n  /* RESPONSIVE PADDING */\r\n  @include m.respond(xl) {\r\n    padding: 80px 2rem;\r\n  }\r\n\r\n  @include m.respond(lg) {\r\n    padding: 70px 1.5rem;\r\n  }\r\n\r\n  @include m.respond(md) {\r\n    padding: 60px 1rem;\r\n  }\r\n\r\n  @include m.respond(sm) {\r\n    padding: 50px 0.75rem;\r\n  }\r\n\r\n  @include m.respond(xs) {\r\n    padding: 40px 0.5rem;\r\n  }\r\n\r\n  /* TITLE */\r\n  .blog-title {\r\n    font-size: clamp(1.4rem, 4vw, 2.2rem);\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n    margin-bottom: v.$spacing-lg;\r\n\r\n    @include m.respond(md) {\r\n      font-size: clamp(1.3rem, 5vw, 1.9rem);\r\n    }\r\n\r\n    @include m.respond(sm) {\r\n      font-size: clamp(1.2rem, 6vw, 1.6rem);\r\n      margin-bottom: v.$spacing-md;\r\n    }\r\n\r\n    @include m.respond(xs) {\r\n      font-size: clamp(1.1rem, 7vw, 1.4rem);\r\n      margin-bottom: v.$spacing-sm;\r\n    }\r\n  }\r\n\r\n  /* GRID */\r\n  .blog-container {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n    justify-items: center;\r\n    margin: 0 auto;\r\n\r\n    @include m.respond(lg) {\r\n      gap: 2rem;\r\n    }\r\n\r\n    @include m.respond(md) {\r\n      max-width: 600px;\r\n      gap: 1.5rem;\r\n    }\r\n\r\n    @include m.respond(sm) {\r\n      grid-template-columns: 1fr;\r\n      max-width: 400px;\r\n    }\r\n  }\r\n\r\n  /* CARD */\r\n  .blog-card {\r\n    width: 100%;\r\n    max-width: 350px;\r\n    background: #fff;\r\n    border-radius: v.$radius-md;\r\n    overflow: hidden;\r\n    box-shadow: v.$shadow-medium;\r\n    display: flex;\r\n    flex-direction: column;\r\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n\r\n    &:hover {\r\n      transform: translateY(-6px);\r\n      box-shadow: 0 12px 24px rgba(0, 0, 0, 0.12);\r\n    }\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 220px;\r\n      object-fit: cover;\r\n\r\n      @include m.respond(sm) {\r\n        height: 180px;\r\n      }\r\n    }\r\n\r\n    &__content {\r\n      padding: 1.5rem;\r\n      text-align: left;\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: 0.75rem;\r\n\r\n      h3 {\r\n        font-size: 1.1rem;\r\n        font-weight: 700;\r\n        color: v.$brand-blue;\r\n        line-height: 1.3;\r\n      }\r\n\r\n      p {\r\n        font-size: 0.95rem;\r\n        color: v.$text-muted;\r\n        line-height: 1.6;\r\n        flex: 1;\r\n      }\r\n\r\n      .read-more {\r\n        align-self: flex-start;\r\n        display: inline-flex;\r\n        align-items: center;\r\n        gap: 6px;\r\n        background: none;\r\n        border: none;\r\n        color: v.$brand-blue;\r\n        font-weight: 600;\r\n        cursor: pointer;\r\n        padding: 0.5rem 0;\r\n        transition: color 0.2s ease, transform 0.2s ease;\r\n\r\n        &__icon {\r\n          transition: transform 0.2s ease;\r\n        }\r\n\r\n        &:hover {\r\n          color: color.scale(v.$brand-blue, $lightness: -10%);\r\n          transform: translateX(2px);\r\n        }\r\n\r\n        &:hover .read-more__icon {\r\n          transform: translateX(4px);\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n/* MODAL OVERLAY */\r\n.modal-overlay {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 1000;\r\n}\r\n\r\n/* MODAL */\r\n.modal {\r\n  background: #fff;\r\n  border-radius: v.$radius-md;\r\n  padding: 2rem;\r\n  max-width: 600px;\r\n  width: 100%;\r\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);\r\n\r\n  h3 {\r\n    font-size: 1.2rem;\r\n    color: v.$brand-blue;\r\n    margin-bottom: 1rem;\r\n  }\r\n\r\n  p {\r\n    font-size: 1rem;\r\n    line-height: 1.7;\r\n    color: v.$dark;\r\n  }\r\n}\r\n","@use \"../variables\" as v;\r\n\r\n.contact {\r\n  max-width: v.$max-width;\r\n  margin: 0 auto;\r\n  padding: clamp(2rem, 5vw, 4rem) clamp(1rem, 3vw, 2rem);\r\n\r\n  /* ---------- TITLE ---------- */\r\n  &__title {\r\n    font-size: clamp(1.4rem, 5vw, 2.2rem);\r\n    font-weight: 800;\r\n    color: v.$brand-blue;\r\n    margin-bottom: clamp(1.5rem, 4vw, 2.5rem);\r\n    text-align: center;\r\n    line-height: 1.2;\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: clamp(1.3rem, 6vw, 1.9rem);\r\n      margin-bottom: clamp(1.25rem, 3vw, 2rem);\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      font-size: clamp(1.2rem, 7vw, 1.6rem);\r\n      margin-bottom: clamp(1rem, 3vw, 1.5rem);\r\n    }\r\n  }\r\n\r\n  /* ---------- GRID LAYOUT ---------- */\r\n  &__grid {\r\n    display: grid;\r\n    grid-template-columns: 1.2fr 0.8fr;\r\n    gap: clamp(1.5rem, 4vw, 2.5rem);\r\n    align-items: start;\r\n\r\n    @media (max-width: 1024px) {\r\n      grid-template-columns: 1fr 0.7fr;\r\n      gap: clamp(1.25rem, 3vw, 2rem);\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      grid-template-columns: 1fr;\r\n      gap: clamp(2rem, 5vw, 3rem);\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      gap: clamp(1.5rem, 4vw, 2.5rem);\r\n    }\r\n  }\r\n\r\n  /* ---------- FORM SECTION ---------- */\r\n  &__form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: clamp(0.75rem, 2vw, 1rem);\r\n\r\n    .input,\r\n    .textarea {\r\n      width: 100%;\r\n      border: 1px solid #ddd;\r\n      border-radius: clamp(6px, 1vw, 8px);\r\n      padding: clamp(12px, 2.5vw, 14px) clamp(14px, 3vw, 16px);\r\n      font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n      outline: none;\r\n      transition: border-color 0.2s, box-shadow 0.2s;\r\n      background: #fafafa;\r\n\r\n      &:focus {\r\n        border-color: v.$brand-blue;\r\n        box-shadow: 0 0 0 3px rgba(36, 52, 109, 0.15);\r\n        background: #fff;\r\n      }\r\n\r\n      @media (max-width: 576px) {\r\n        font-size: clamp(0.85rem, 3vw, 0.95rem);\r\n        padding: clamp(10px, 2vw, 12px) clamp(12px, 2.5vw, 14px);\r\n        border-radius: 6px;\r\n      }\r\n\r\n      @media (max-width: 480px) {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n\r\n    .textarea {\r\n      min-height: clamp(120px, 20vw, 150px);\r\n      resize: vertical;\r\n      line-height: 1.5;\r\n\r\n      @media (max-width: 768px) {\r\n        min-height: clamp(100px, 15vw, 120px);\r\n      }\r\n\r\n      @media (max-width: 576px) {\r\n        min-height: clamp(80px, 12vw, 100px);\r\n        resize: none;\r\n      }\r\n    }\r\n\r\n    .contact__button-wrapper {\r\n      display: flex;\r\n      justify-content: center;\r\n      margin-top: clamp(0.5rem, 2vw, 1rem);\r\n\r\n      .contact__submit {\r\n        border: 2px solid v.$brand-blue;\r\n        background: transparent;\r\n        color: v.$brand-blue;\r\n        font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n        font-weight: 600;\r\n        padding: clamp(10px, 2vw, 12px) clamp(30px, 6vw, 40px);\r\n        border-radius: 40px;\r\n        cursor: pointer;\r\n        transition: all 0.25s ease;\r\n\r\n        &:hover {\r\n          background: v.$brand-blue;\r\n          color: white;\r\n          transform: translateY(-2px);\r\n        }\r\n\r\n        @media (max-width: 576px) {\r\n          width: 100%;\r\n          font-size: clamp(0.85rem, 3vw, 0.95rem);\r\n          padding: clamp(12px, 2.5vw, 14px) 0;\r\n          border-radius: 8px;\r\n          justify-content: center;\r\n\r\n        }\r\n      }\r\n    }\r\n\r\n    .form-status {\r\n      text-align: center;\r\n      margin-top: clamp(0.6rem, 2vw, 0.8rem);\r\n      font-weight: 600;\r\n      font-size: clamp(0.85rem, 2vw, 0.95rem);\r\n\r\n      &.ok {\r\n        color: #18a957;\r\n      }\r\n\r\n      &.err {\r\n        color: #d64545;\r\n      }\r\n    }\r\n  }\r\n  /* ---------- SOCIAL LINKS ---------- */\r\n  /* ---------- SOCIAL ICONS ---------- */\r\n  .contact__socials {\r\n    .social-icons {\r\n      display: flex;\r\n      gap: clamp(10px, 2vw, 16px);\r\n\r\n      a {\r\n        width: 42px;\r\n        height: 42px;\r\n        border-radius: 50%;\r\n        border: 1.5px solid rgba(0, 0, 0, 0.15);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        color: v.$brand-blue;\r\n        font-size: 1.2rem;\r\n        transition: all 0.25s ease;\r\n        background: #fff;\r\n\r\n        &:hover {\r\n          background: v.$brand-blue;\r\n          color: #fff;\r\n          transform: translateY(-3px);\r\n          box-shadow: 0 8px 20px rgba(36, 52, 109, 0.25);\r\n        }\r\n      }\r\n\r\n      @media (max-width: 768px) {\r\n        justify-content: center;\r\n      }\r\n    }\r\n  }\r\n\r\n\r\n  /* ---------- INFO SECTION ---------- */\r\n  &__info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: flex-start;\r\n    border-left: 1px solid rgba(0, 0, 0, 0.1);\r\n    padding-left: clamp(1rem, 3vw, 2rem);\r\n    gap: clamp(1rem, 2.5vw, 1.5rem);\r\n\r\n    @media (max-width: 1024px) {\r\n      gap: clamp(0.8rem, 2vw, 1.2rem);\r\n      padding-left: clamp(0.75rem, 2vw, 1.5rem);\r\n    }\r\n\r\n    @media (max-width: 768px) {\r\n      border-left: none;\r\n      border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n      padding-left: 0;\r\n      padding-top: clamp(1.5rem, 4vw, 2rem);\r\n      align-items: center;\r\n      text-align: center;\r\n      gap: clamp(1.25rem, 3vw, 1.5rem);\r\n    }\r\n\r\n    @media (max-width: 576px) {\r\n      gap: clamp(1rem, 2.5vw, 1.25rem);\r\n      padding-top: clamp(1rem, 3vw, 1.5rem);\r\n    }\r\n\r\n    .info-item {\r\n      h4 {\r\n        font-size: clamp(0.9rem, 2.5vw, 1rem);\r\n        color: v.$brand-blue;\r\n        margin-bottom: clamp(4px, 1vw, 6px);\r\n        font-weight: 600;\r\n\r\n        @media (max-width: 576px) {\r\n          font-size: clamp(0.85rem, 3vw, 0.95rem);\r\n        }\r\n      }\r\n\r\n      a,\r\n      p {\r\n        color: v.$dark;\r\n        text-decoration: none;\r\n        font-size: clamp(0.85rem, 2.2vw, 1rem);\r\n        line-height: 1.4;\r\n\r\n        @media (max-width: 576px) {\r\n          font-size: clamp(0.8rem, 2.5vw, 0.9rem);\r\n        }\r\n      }\r\n\r\n      a:hover {\r\n        color: v.$brand-blue;\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n  }\r\n\r\n  /* ---------- RESPONSIVE PADDING ---------- */\r\n  @media (max-width: 1200px) {\r\n    padding: clamp(1.5rem, 4vw, 3rem) clamp(1.5rem, 4vw, 2rem);\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    padding: clamp(1.25rem, 3vw, 2rem) clamp(1rem, 2.5vw, 1.5rem);\r\n  }\r\n\r\n  @media (max-width: 576px) {\r\n    padding: clamp(1rem, 2.5vw, 1.5rem) clamp(0.75rem, 2vw, 1rem);\r\n  }\r\n\r\n  @media (max-width: 480px) {\r\n    padding: clamp(0.75rem, 2vw, 1rem) clamp(0.5rem, 1.5vw, 0.75rem);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
